/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const KVPair = $root.KVPair = (() => {

    /**
     * Properties of a KVPair.
     * @exports IKVPair
     * @interface IKVPair
     * @property {string|null} [key] KVPair key
     * @property {string|null} [value] KVPair value
     */

    /**
     * Constructs a new KVPair.
     * @exports KVPair
     * @classdesc Represents a KVPair.
     * @implements IKVPair
     * @constructor
     * @param {IKVPair=} [properties] Properties to set
     */
    function KVPair(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * KVPair key.
     * @member {string} key
     * @memberof KVPair
     * @instance
     */
    KVPair.prototype.key = "";

    /**
     * KVPair value.
     * @member {string} value
     * @memberof KVPair
     * @instance
     */
    KVPair.prototype.value = "";

    /**
     * Creates a new KVPair instance using the specified properties.
     * @function create
     * @memberof KVPair
     * @static
     * @param {IKVPair=} [properties] Properties to set
     * @returns {KVPair} KVPair instance
     */
    KVPair.create = function create(properties) {
        return new KVPair(properties);
    };

    /**
     * Encodes the specified KVPair message. Does not implicitly {@link KVPair.verify|verify} messages.
     * @function encode
     * @memberof KVPair
     * @static
     * @param {IKVPair} message KVPair message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KVPair.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);}
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);}
        return writer;
    };

    /**
     * Encodes the specified KVPair message, length delimited. Does not implicitly {@link KVPair.verify|verify} messages.
     * @function encodeDelimited
     * @memberof KVPair
     * @static
     * @param {IKVPair} message KVPair message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KVPair.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a KVPair message from the specified reader or buffer.
     * @function decode
     * @memberof KVPair
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KVPair} KVPair
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KVPair.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KVPair();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.key = reader.string();
                break;
            }
            case 2: {
                message.value = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a KVPair message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof KVPair
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {KVPair} KVPair
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KVPair.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a KVPair message.
     * @function verify
     * @memberof KVPair
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    KVPair.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        if (message.key != null && message.hasOwnProperty("key"))
        {if (!$util.isString(message.key))
        {return "key: string expected";}}
        if (message.value != null && message.hasOwnProperty("value"))
        {if (!$util.isString(message.value))
        {return "value: string expected";}}
        return null;
    };

    /**
     * Creates a KVPair message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KVPair
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KVPair} KVPair
     */
    KVPair.fromObject = function fromObject(object) {
        if (object instanceof $root.KVPair)
        {return object;}
        let message = new $root.KVPair();
        if (object.key != null)
        {message.key = String(object.key);}
        if (object.value != null)
        {message.value = String(object.value);}
        return message;
    };

    /**
     * Creates a plain object from a KVPair message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KVPair
     * @static
     * @param {KVPair} message KVPair
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KVPair.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults) {
            object.key = "";
            object.value = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
        {object.key = message.key;}
        if (message.value != null && message.hasOwnProperty("value"))
        {object.value = message.value;}
        return object;
    };

    /**
     * Converts this KVPair to JSON.
     * @function toJSON
     * @memberof KVPair
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KVPair.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KVPair
     * @function getTypeUrl
     * @memberof KVPair
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KVPair.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KVPair";
    };

    return KVPair;
})();

export const Address = $root.Address = (() => {

    /**
     * Properties of an Address.
     * @exports IAddress
     * @interface IAddress
     * @property {string|null} [country] Address country
     * @property {string|null} [city] Address city
     * @property {string|null} [postalCode] Address postalCode
     * @property {string|null} [line1] Address line1
     * @property {string|null} [line2] Address line2
     */

    /**
     * Constructs a new Address.
     * @exports Address
     * @classdesc Represents an Address.
     * @implements IAddress
     * @constructor
     * @param {IAddress=} [properties] Properties to set
     */
    function Address(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * Address country.
     * @member {string} country
     * @memberof Address
     * @instance
     */
    Address.prototype.country = "";

    /**
     * Address city.
     * @member {string} city
     * @memberof Address
     * @instance
     */
    Address.prototype.city = "";

    /**
     * Address postalCode.
     * @member {string} postalCode
     * @memberof Address
     * @instance
     */
    Address.prototype.postalCode = "";

    /**
     * Address line1.
     * @member {string} line1
     * @memberof Address
     * @instance
     */
    Address.prototype.line1 = "";

    /**
     * Address line2.
     * @member {string} line2
     * @memberof Address
     * @instance
     */
    Address.prototype.line2 = "";

    /**
     * Creates a new Address instance using the specified properties.
     * @function create
     * @memberof Address
     * @static
     * @param {IAddress=} [properties] Properties to set
     * @returns {Address} Address instance
     */
    Address.create = function create(properties) {
        return new Address(properties);
    };

    /**
     * Encodes the specified Address message. Does not implicitly {@link Address.verify|verify} messages.
     * @function encode
     * @memberof Address
     * @static
     * @param {IAddress} message Address message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Address.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.country != null && Object.hasOwnProperty.call(message, "country"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.country);}
        if (message.city != null && Object.hasOwnProperty.call(message, "city"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.city);}
        if (message.postalCode != null && Object.hasOwnProperty.call(message, "postalCode"))
        {writer.uint32(/* id 3, wireType 2 =*/26).string(message.postalCode);}
        if (message.line1 != null && Object.hasOwnProperty.call(message, "line1"))
        {writer.uint32(/* id 4, wireType 2 =*/34).string(message.line1);}
        if (message.line2 != null && Object.hasOwnProperty.call(message, "line2"))
        {writer.uint32(/* id 5, wireType 2 =*/42).string(message.line2);}
        return writer;
    };

    /**
     * Encodes the specified Address message, length delimited. Does not implicitly {@link Address.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Address
     * @static
     * @param {IAddress} message Address message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Address.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Address message from the specified reader or buffer.
     * @function decode
     * @memberof Address
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Address} Address
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Address.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Address();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.country = reader.string();
                break;
            }
            case 2: {
                message.city = reader.string();
                break;
            }
            case 3: {
                message.postalCode = reader.string();
                break;
            }
            case 4: {
                message.line1 = reader.string();
                break;
            }
            case 5: {
                message.line2 = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Address message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Address
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Address} Address
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Address.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Address message.
     * @function verify
     * @memberof Address
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Address.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        if (message.country != null && message.hasOwnProperty("country"))
        {if (!$util.isString(message.country))
        {return "country: string expected";}}
        if (message.city != null && message.hasOwnProperty("city"))
        {if (!$util.isString(message.city))
        {return "city: string expected";}}
        if (message.postalCode != null && message.hasOwnProperty("postalCode"))
        {if (!$util.isString(message.postalCode))
        {return "postalCode: string expected";}}
        if (message.line1 != null && message.hasOwnProperty("line1"))
        {if (!$util.isString(message.line1))
        {return "line1: string expected";}}
        if (message.line2 != null && message.hasOwnProperty("line2"))
        {if (!$util.isString(message.line2))
        {return "line2: string expected";}}
        return null;
    };

    /**
     * Creates an Address message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Address
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Address} Address
     */
    Address.fromObject = function fromObject(object) {
        if (object instanceof $root.Address)
        {return object;}
        let message = new $root.Address();
        if (object.country != null)
        {message.country = String(object.country);}
        if (object.city != null)
        {message.city = String(object.city);}
        if (object.postalCode != null)
        {message.postalCode = String(object.postalCode);}
        if (object.line1 != null)
        {message.line1 = String(object.line1);}
        if (object.line2 != null)
        {message.line2 = String(object.line2);}
        return message;
    };

    /**
     * Creates a plain object from an Address message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Address
     * @static
     * @param {Address} message Address
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Address.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults) {
            object.country = "";
            object.city = "";
            object.postalCode = "";
            object.line1 = "";
            object.line2 = "";
        }
        if (message.country != null && message.hasOwnProperty("country"))
        {object.country = message.country;}
        if (message.city != null && message.hasOwnProperty("city"))
        {object.city = message.city;}
        if (message.postalCode != null && message.hasOwnProperty("postalCode"))
        {object.postalCode = message.postalCode;}
        if (message.line1 != null && message.hasOwnProperty("line1"))
        {object.line1 = message.line1;}
        if (message.line2 != null && message.hasOwnProperty("line2"))
        {object.line2 = message.line2;}
        return object;
    };

    /**
     * Converts this Address to JSON.
     * @function toJSON
     * @memberof Address
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Address.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Address
     * @function getTypeUrl
     * @memberof Address
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Address.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Address";
    };

    return Address;
})();

export const CDNFile = $root.CDNFile = (() => {

    /**
     * Properties of a CDNFile.
     * @exports ICDNFile
     * @interface ICDNFile
     * @property {string|null} [src] CDNFile src
     */

    /**
     * Constructs a new CDNFile.
     * @exports CDNFile
     * @classdesc Represents a CDNFile.
     * @implements ICDNFile
     * @constructor
     * @param {ICDNFile=} [properties] Properties to set
     */
    function CDNFile(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * CDNFile src.
     * @member {string} src
     * @memberof CDNFile
     * @instance
     */
    CDNFile.prototype.src = "";

    /**
     * Creates a new CDNFile instance using the specified properties.
     * @function create
     * @memberof CDNFile
     * @static
     * @param {ICDNFile=} [properties] Properties to set
     * @returns {CDNFile} CDNFile instance
     */
    CDNFile.create = function create(properties) {
        return new CDNFile(properties);
    };

    /**
     * Encodes the specified CDNFile message. Does not implicitly {@link CDNFile.verify|verify} messages.
     * @function encode
     * @memberof CDNFile
     * @static
     * @param {ICDNFile} message CDNFile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CDNFile.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.src != null && Object.hasOwnProperty.call(message, "src"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.src);}
        return writer;
    };

    /**
     * Encodes the specified CDNFile message, length delimited. Does not implicitly {@link CDNFile.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CDNFile
     * @static
     * @param {ICDNFile} message CDNFile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CDNFile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CDNFile message from the specified reader or buffer.
     * @function decode
     * @memberof CDNFile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CDNFile} CDNFile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CDNFile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CDNFile();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.src = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CDNFile message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CDNFile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CDNFile} CDNFile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CDNFile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CDNFile message.
     * @function verify
     * @memberof CDNFile
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CDNFile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        if (message.src != null && message.hasOwnProperty("src"))
        {if (!$util.isString(message.src))
        {return "src: string expected";}}
        return null;
    };

    /**
     * Creates a CDNFile message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CDNFile
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CDNFile} CDNFile
     */
    CDNFile.fromObject = function fromObject(object) {
        if (object instanceof $root.CDNFile)
        {return object;}
        let message = new $root.CDNFile();
        if (object.src != null)
        {message.src = String(object.src);}
        return message;
    };

    /**
     * Creates a plain object from a CDNFile message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CDNFile
     * @static
     * @param {CDNFile} message CDNFile
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CDNFile.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults)
        {object.src = "";}
        if (message.src != null && message.hasOwnProperty("src"))
        {object.src = message.src;}
        return object;
    };

    /**
     * Converts this CDNFile to JSON.
     * @function toJSON
     * @memberof CDNFile
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CDNFile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CDNFile
     * @function getTypeUrl
     * @memberof CDNFile
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CDNFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CDNFile";
    };

    return CDNFile;
})();

export const User = $root.User = (() => {

    /**
     * Properties of a User.
     * @exports IUser
     * @interface IUser
     * @property {string|null} [id] User id
     * @property {string|null} [userType] User userType
     */

    /**
     * Constructs a new User.
     * @exports User
     * @classdesc Represents a User.
     * @implements IUser
     * @constructor
     * @param {IUser=} [properties] Properties to set
     */
    function User(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * User id.
     * @member {string|null|undefined} id
     * @memberof User
     * @instance
     */
    User.prototype.id = null;

    /**
     * User userType.
     * @member {string|null|undefined} userType
     * @memberof User
     * @instance
     */
    User.prototype.userType = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * User _id.
     * @member {"id"|undefined} _id
     * @memberof User
     * @instance
     */
    Object.defineProperty(User.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * User _userType.
     * @member {"userType"|undefined} _userType
     * @memberof User
     * @instance
     */
    Object.defineProperty(User.prototype, "_userType", {
        get: $util.oneOfGetter($oneOfFields = ["userType"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new User instance using the specified properties.
     * @function create
     * @memberof User
     * @static
     * @param {IUser=} [properties] Properties to set
     * @returns {User} User instance
     */
    User.create = function create(properties) {
        return new User(properties);
    };

    /**
     * Encodes the specified User message. Does not implicitly {@link User.verify|verify} messages.
     * @function encode
     * @memberof User
     * @static
     * @param {IUser} message User message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    User.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);}
        if (message.userType != null && Object.hasOwnProperty.call(message, "userType"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.userType);}
        return writer;
    };

    /**
     * Encodes the specified User message, length delimited. Does not implicitly {@link User.verify|verify} messages.
     * @function encodeDelimited
     * @memberof User
     * @static
     * @param {IUser} message User message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    User.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a User message from the specified reader or buffer.
     * @function decode
     * @memberof User
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {User} User
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    User.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.User();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.id = reader.string();
                break;
            }
            case 2: {
                message.userType = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a User message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof User
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {User} User
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    User.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a User message.
     * @function verify
     * @memberof User
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    User.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isString(message.id))
            {return "id: string expected";}
        }
        if (message.userType != null && message.hasOwnProperty("userType")) {
            properties._userType = 1;
            if (!$util.isString(message.userType))
            {return "userType: string expected";}
        }
        return null;
    };

    /**
     * Creates a User message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof User
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {User} User
     */
    User.fromObject = function fromObject(object) {
        if (object instanceof $root.User)
        {return object;}
        let message = new $root.User();
        if (object.id != null)
        {message.id = String(object.id);}
        if (object.userType != null)
        {message.userType = String(object.userType);}
        return message;
    };

    /**
     * Creates a plain object from a User message. Also converts values to other types if specified.
     * @function toObject
     * @memberof User
     * @static
     * @param {User} message User
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    User.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
            {object._id = "id";}
        }
        if (message.userType != null && message.hasOwnProperty("userType")) {
            object.userType = message.userType;
            if (options.oneofs)
            {object._userType = "userType";}
        }
        return object;
    };

    /**
     * Converts this User to JSON.
     * @function toJSON
     * @memberof User
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    User.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for User
     * @function getTypeUrl
     * @memberof User
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    User.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/User";
    };

    return User;
})();

export const Reviewer = $root.Reviewer = (() => {

    /**
     * Properties of a Reviewer.
     * @exports IReviewer
     * @interface IReviewer
     * @property {string|null} [id] Reviewer id
     * @property {string|null} [email] Reviewer email
     * @property {IReviewerProfile|null} [profile] Reviewer profile
     * @property {ICDNFile|null} [profileImage] Reviewer profileImage
     * @property {IReviewerSocials|null} [socials] Reviewer socials
     * @property {boolean|null} [isBlacklisted] Reviewer isBlacklisted
     * @property {number|Long|null} [blacklistedUntil] Reviewer blacklistedUntil
     * @property {Array.<IBlacklistHistoryRecord>|null} [blacklistHistory] Reviewer blacklistHistory
     * @property {IReviewerNote|null} [note] Reviewer note
     * @property {number|null} [totalApplicationsCount] Reviewer totalApplicationsCount
     * @property {number|null} [selectedApplicationsCount] Reviewer selectedApplicationsCount
     * @property {number|null} [alternateApplicationsCount] Reviewer alternateApplicationsCount
     * @property {number|null} [rejectedApplicationsCount] Reviewer rejectedApplicationsCount
     * @property {Array.<IReviewerApplicationsHistoryRecord>|null} [applicationsHistory] Reviewer applicationsHistory
     * @property {IReviewerClientCount|null} [clientCounts] Reviewer clientCounts
     */

    /**
     * Constructs a new Reviewer.
     * @exports Reviewer
     * @classdesc Represents a Reviewer.
     * @implements IReviewer
     * @constructor
     * @param {IReviewer=} [properties] Properties to set
     */
    function Reviewer(properties) {
        this.blacklistHistory = [];
        this.applicationsHistory = [];
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * Reviewer id.
     * @member {string} id
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.id = "";

    /**
     * Reviewer email.
     * @member {string} email
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.email = "";

    /**
     * Reviewer profile.
     * @member {IReviewerProfile|null|undefined} profile
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.profile = null;

    /**
     * Reviewer profileImage.
     * @member {ICDNFile|null|undefined} profileImage
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.profileImage = null;

    /**
     * Reviewer socials.
     * @member {IReviewerSocials|null|undefined} socials
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.socials = null;

    /**
     * Reviewer isBlacklisted.
     * @member {boolean|null|undefined} isBlacklisted
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.isBlacklisted = null;

    /**
     * Reviewer blacklistedUntil.
     * @member {number|Long|null|undefined} blacklistedUntil
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.blacklistedUntil = null;

    /**
     * Reviewer blacklistHistory.
     * @member {Array.<IBlacklistHistoryRecord>} blacklistHistory
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.blacklistHistory = $util.emptyArray;

    /**
     * Reviewer note.
     * @member {IReviewerNote|null|undefined} note
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.note = null;

    /**
     * Reviewer totalApplicationsCount.
     * @member {number|null|undefined} totalApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.totalApplicationsCount = null;

    /**
     * Reviewer selectedApplicationsCount.
     * @member {number|null|undefined} selectedApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.selectedApplicationsCount = null;

    /**
     * Reviewer alternateApplicationsCount.
     * @member {number|null|undefined} alternateApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.alternateApplicationsCount = null;

    /**
     * Reviewer rejectedApplicationsCount.
     * @member {number|null|undefined} rejectedApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.rejectedApplicationsCount = null;

    /**
     * Reviewer applicationsHistory.
     * @member {Array.<IReviewerApplicationsHistoryRecord>} applicationsHistory
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.applicationsHistory = $util.emptyArray;

    /**
     * Reviewer clientCounts.
     * @member {IReviewerClientCount|null|undefined} clientCounts
     * @memberof Reviewer
     * @instance
     */
    Reviewer.prototype.clientCounts = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Reviewer _profileImage.
     * @member {"profileImage"|undefined} _profileImage
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_profileImage", {
        get: $util.oneOfGetter($oneOfFields = ["profileImage"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _socials.
     * @member {"socials"|undefined} _socials
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_socials", {
        get: $util.oneOfGetter($oneOfFields = ["socials"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _isBlacklisted.
     * @member {"isBlacklisted"|undefined} _isBlacklisted
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_isBlacklisted", {
        get: $util.oneOfGetter($oneOfFields = ["isBlacklisted"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _blacklistedUntil.
     * @member {"blacklistedUntil"|undefined} _blacklistedUntil
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_blacklistedUntil", {
        get: $util.oneOfGetter($oneOfFields = ["blacklistedUntil"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _note.
     * @member {"note"|undefined} _note
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_note", {
        get: $util.oneOfGetter($oneOfFields = ["note"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _totalApplicationsCount.
     * @member {"totalApplicationsCount"|undefined} _totalApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_totalApplicationsCount", {
        get: $util.oneOfGetter($oneOfFields = ["totalApplicationsCount"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _selectedApplicationsCount.
     * @member {"selectedApplicationsCount"|undefined} _selectedApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_selectedApplicationsCount", {
        get: $util.oneOfGetter($oneOfFields = ["selectedApplicationsCount"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _alternateApplicationsCount.
     * @member {"alternateApplicationsCount"|undefined} _alternateApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_alternateApplicationsCount", {
        get: $util.oneOfGetter($oneOfFields = ["alternateApplicationsCount"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _rejectedApplicationsCount.
     * @member {"rejectedApplicationsCount"|undefined} _rejectedApplicationsCount
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_rejectedApplicationsCount", {
        get: $util.oneOfGetter($oneOfFields = ["rejectedApplicationsCount"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Reviewer _clientCounts.
     * @member {"clientCounts"|undefined} _clientCounts
     * @memberof Reviewer
     * @instance
     */
    Object.defineProperty(Reviewer.prototype, "_clientCounts", {
        get: $util.oneOfGetter($oneOfFields = ["clientCounts"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Reviewer instance using the specified properties.
     * @function create
     * @memberof Reviewer
     * @static
     * @param {IReviewer=} [properties] Properties to set
     * @returns {Reviewer} Reviewer instance
     */
    Reviewer.create = function create(properties) {
        return new Reviewer(properties);
    };

    /**
     * Encodes the specified Reviewer message. Does not implicitly {@link Reviewer.verify|verify} messages.
     * @function encode
     * @memberof Reviewer
     * @static
     * @param {IReviewer} message Reviewer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Reviewer.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);}
        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);}
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
        {$root.ReviewerProfile.encode(message.profile, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();}
        if (message.profileImage != null && Object.hasOwnProperty.call(message, "profileImage"))
        {$root.CDNFile.encode(message.profileImage, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();}
        if (message.socials != null && Object.hasOwnProperty.call(message, "socials"))
        {$root.ReviewerSocials.encode(message.socials, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();}
        if (message.isBlacklisted != null && Object.hasOwnProperty.call(message, "isBlacklisted"))
        {writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isBlacklisted);}
        if (message.blacklistedUntil != null && Object.hasOwnProperty.call(message, "blacklistedUntil"))
        {writer.uint32(/* id 7, wireType 0 =*/56).int64(message.blacklistedUntil);}
        if (message.blacklistHistory != null && message.blacklistHistory.length)
        {for (let i = 0; i < message.blacklistHistory.length; ++i)
        {$root.BlacklistHistoryRecord.encode(message.blacklistHistory[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();}}
        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
        {$root.ReviewerNote.encode(message.note, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();}
        if (message.totalApplicationsCount != null && Object.hasOwnProperty.call(message, "totalApplicationsCount"))
        {writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.totalApplicationsCount);}
        if (message.selectedApplicationsCount != null && Object.hasOwnProperty.call(message, "selectedApplicationsCount"))
        {writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.selectedApplicationsCount);}
        if (message.alternateApplicationsCount != null && Object.hasOwnProperty.call(message, "alternateApplicationsCount"))
        {writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.alternateApplicationsCount);}
        if (message.rejectedApplicationsCount != null && Object.hasOwnProperty.call(message, "rejectedApplicationsCount"))
        {writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.rejectedApplicationsCount);}
        if (message.applicationsHistory != null && message.applicationsHistory.length)
        {for (let i = 0; i < message.applicationsHistory.length; ++i)
        {$root.ReviewerApplicationsHistoryRecord.encode(message.applicationsHistory[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();}}
        if (message.clientCounts != null && Object.hasOwnProperty.call(message, "clientCounts"))
        {$root.ReviewerClientCount.encode(message.clientCounts, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();}
        return writer;
    };

    /**
     * Encodes the specified Reviewer message, length delimited. Does not implicitly {@link Reviewer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Reviewer
     * @static
     * @param {IReviewer} message Reviewer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Reviewer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Reviewer message from the specified reader or buffer.
     * @function decode
     * @memberof Reviewer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Reviewer} Reviewer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Reviewer.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Reviewer();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.id = reader.string();
                break;
            }
            case 2: {
                message.email = reader.string();
                break;
            }
            case 3: {
                message.profile = $root.ReviewerProfile.decode(reader, reader.uint32());
                break;
            }
            case 4: {
                message.profileImage = $root.CDNFile.decode(reader, reader.uint32());
                break;
            }
            case 5: {
                message.socials = $root.ReviewerSocials.decode(reader, reader.uint32());
                break;
            }
            case 6: {
                message.isBlacklisted = reader.bool();
                break;
            }
            case 7: {
                message.blacklistedUntil = reader.int64();
                break;
            }
            case 8: {
                if (!(message.blacklistHistory && message.blacklistHistory.length))
                {message.blacklistHistory = [];}
                message.blacklistHistory.push($root.BlacklistHistoryRecord.decode(reader, reader.uint32()));
                break;
            }
            case 9: {
                message.note = $root.ReviewerNote.decode(reader, reader.uint32());
                break;
            }
            case 10: {
                message.totalApplicationsCount = reader.uint32();
                break;
            }
            case 11: {
                message.selectedApplicationsCount = reader.uint32();
                break;
            }
            case 12: {
                message.alternateApplicationsCount = reader.uint32();
                break;
            }
            case 13: {
                message.rejectedApplicationsCount = reader.uint32();
                break;
            }
            case 14: {
                if (!(message.applicationsHistory && message.applicationsHistory.length))
                {message.applicationsHistory = [];}
                message.applicationsHistory.push($root.ReviewerApplicationsHistoryRecord.decode(reader, reader.uint32()));
                break;
            }
            case 15: {
                message.clientCounts = $root.ReviewerClientCount.decode(reader, reader.uint32());
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Reviewer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Reviewer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Reviewer} Reviewer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Reviewer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Reviewer message.
     * @function verify
     * @memberof Reviewer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Reviewer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id"))
        {if (!$util.isString(message.id))
        {return "id: string expected";}}
        if (message.email != null && message.hasOwnProperty("email"))
        {if (!$util.isString(message.email))
        {return "email: string expected";}}
        if (message.profile != null && message.hasOwnProperty("profile")) {
            let error = $root.ReviewerProfile.verify(message.profile);
            if (error)
            {return "profile." + error;}
        }
        if (message.profileImage != null && message.hasOwnProperty("profileImage")) {
            properties._profileImage = 1;
            {
                let error = $root.CDNFile.verify(message.profileImage);
                if (error)
                {return "profileImage." + error;}
            }
        }
        if (message.socials != null && message.hasOwnProperty("socials")) {
            properties._socials = 1;
            {
                let error = $root.ReviewerSocials.verify(message.socials);
                if (error)
                {return "socials." + error;}
            }
        }
        if (message.isBlacklisted != null && message.hasOwnProperty("isBlacklisted")) {
            properties._isBlacklisted = 1;
            if (typeof message.isBlacklisted !== "boolean")
            {return "isBlacklisted: boolean expected";}
        }
        if (message.blacklistedUntil != null && message.hasOwnProperty("blacklistedUntil")) {
            properties._blacklistedUntil = 1;
            if (!$util.isInteger(message.blacklistedUntil) && !(message.blacklistedUntil && $util.isInteger(message.blacklistedUntil.low) && $util.isInteger(message.blacklistedUntil.high)))
            {return "blacklistedUntil: integer|Long expected";}
        }
        if (message.blacklistHistory != null && message.hasOwnProperty("blacklistHistory")) {
            if (!Array.isArray(message.blacklistHistory))
            {return "blacklistHistory: array expected";}
            for (let i = 0; i < message.blacklistHistory.length; ++i) {
                let error = $root.BlacklistHistoryRecord.verify(message.blacklistHistory[i]);
                if (error)
                {return "blacklistHistory." + error;}
            }
        }
        if (message.note != null && message.hasOwnProperty("note")) {
            properties._note = 1;
            {
                let error = $root.ReviewerNote.verify(message.note);
                if (error)
                {return "note." + error;}
            }
        }
        if (message.totalApplicationsCount != null && message.hasOwnProperty("totalApplicationsCount")) {
            properties._totalApplicationsCount = 1;
            if (!$util.isInteger(message.totalApplicationsCount))
            {return "totalApplicationsCount: integer expected";}
        }
        if (message.selectedApplicationsCount != null && message.hasOwnProperty("selectedApplicationsCount")) {
            properties._selectedApplicationsCount = 1;
            if (!$util.isInteger(message.selectedApplicationsCount))
            {return "selectedApplicationsCount: integer expected";}
        }
        if (message.alternateApplicationsCount != null && message.hasOwnProperty("alternateApplicationsCount")) {
            properties._alternateApplicationsCount = 1;
            if (!$util.isInteger(message.alternateApplicationsCount))
            {return "alternateApplicationsCount: integer expected";}
        }
        if (message.rejectedApplicationsCount != null && message.hasOwnProperty("rejectedApplicationsCount")) {
            properties._rejectedApplicationsCount = 1;
            if (!$util.isInteger(message.rejectedApplicationsCount))
            {return "rejectedApplicationsCount: integer expected";}
        }
        if (message.applicationsHistory != null && message.hasOwnProperty("applicationsHistory")) {
            if (!Array.isArray(message.applicationsHistory))
            {return "applicationsHistory: array expected";}
            for (let i = 0; i < message.applicationsHistory.length; ++i) {
                let error = $root.ReviewerApplicationsHistoryRecord.verify(message.applicationsHistory[i]);
                if (error)
                {return "applicationsHistory." + error;}
            }
        }
        if (message.clientCounts != null && message.hasOwnProperty("clientCounts")) {
            properties._clientCounts = 1;
            {
                let error = $root.ReviewerClientCount.verify(message.clientCounts);
                if (error)
                {return "clientCounts." + error;}
            }
        }
        return null;
    };

    /**
     * Creates a Reviewer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Reviewer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Reviewer} Reviewer
     */
    Reviewer.fromObject = function fromObject(object) {
        if (object instanceof $root.Reviewer)
        {return object;}
        let message = new $root.Reviewer();
        if (object.id != null)
        {message.id = String(object.id);}
        if (object.email != null)
        {message.email = String(object.email);}
        if (object.profile != null) {
            if (typeof object.profile !== "object")
            {throw TypeError(".Reviewer.profile: object expected");}
            message.profile = $root.ReviewerProfile.fromObject(object.profile);
        }
        if (object.profileImage != null) {
            if (typeof object.profileImage !== "object")
            {throw TypeError(".Reviewer.profileImage: object expected");}
            message.profileImage = $root.CDNFile.fromObject(object.profileImage);
        }
        if (object.socials != null) {
            if (typeof object.socials !== "object")
            {throw TypeError(".Reviewer.socials: object expected");}
            message.socials = $root.ReviewerSocials.fromObject(object.socials);
        }
        if (object.isBlacklisted != null)
        {message.isBlacklisted = Boolean(object.isBlacklisted);}
        if (object.blacklistedUntil != null)
        {if ($util.Long)
        {(message.blacklistedUntil = $util.Long.fromValue(object.blacklistedUntil)).unsigned = false;}
        else if (typeof object.blacklistedUntil === "string")
        {message.blacklistedUntil = parseInt(object.blacklistedUntil, 10);}
        else if (typeof object.blacklistedUntil === "number")
        {message.blacklistedUntil = object.blacklistedUntil;}
        else if (typeof object.blacklistedUntil === "object")
        {message.blacklistedUntil = new $util.LongBits(object.blacklistedUntil.low >>> 0, object.blacklistedUntil.high >>> 0).toNumber();}}
        if (object.blacklistHistory) {
            if (!Array.isArray(object.blacklistHistory))
            {throw TypeError(".Reviewer.blacklistHistory: array expected");}
            message.blacklistHistory = [];
            for (let i = 0; i < object.blacklistHistory.length; ++i) {
                if (typeof object.blacklistHistory[i] !== "object")
                {throw TypeError(".Reviewer.blacklistHistory: object expected");}
                message.blacklistHistory[i] = $root.BlacklistHistoryRecord.fromObject(object.blacklistHistory[i]);
            }
        }
        if (object.note != null) {
            if (typeof object.note !== "object")
            {throw TypeError(".Reviewer.note: object expected");}
            message.note = $root.ReviewerNote.fromObject(object.note);
        }
        if (object.totalApplicationsCount != null)
        {message.totalApplicationsCount = object.totalApplicationsCount >>> 0;}
        if (object.selectedApplicationsCount != null)
        {message.selectedApplicationsCount = object.selectedApplicationsCount >>> 0;}
        if (object.alternateApplicationsCount != null)
        {message.alternateApplicationsCount = object.alternateApplicationsCount >>> 0;}
        if (object.rejectedApplicationsCount != null)
        {message.rejectedApplicationsCount = object.rejectedApplicationsCount >>> 0;}
        if (object.applicationsHistory) {
            if (!Array.isArray(object.applicationsHistory))
            {throw TypeError(".Reviewer.applicationsHistory: array expected");}
            message.applicationsHistory = [];
            for (let i = 0; i < object.applicationsHistory.length; ++i) {
                if (typeof object.applicationsHistory[i] !== "object")
                {throw TypeError(".Reviewer.applicationsHistory: object expected");}
                message.applicationsHistory[i] = $root.ReviewerApplicationsHistoryRecord.fromObject(object.applicationsHistory[i]);
            }
        }
        if (object.clientCounts != null) {
            if (typeof object.clientCounts !== "object")
            {throw TypeError(".Reviewer.clientCounts: object expected");}
            message.clientCounts = $root.ReviewerClientCount.fromObject(object.clientCounts);
        }
        return message;
    };

    /**
     * Creates a plain object from a Reviewer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Reviewer
     * @static
     * @param {Reviewer} message Reviewer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Reviewer.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.arrays || options.defaults) {
            object.blacklistHistory = [];
            object.applicationsHistory = [];
        }
        if (options.defaults) {
            object.id = "";
            object.email = "";
            object.profile = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
        {object.id = message.id;}
        if (message.email != null && message.hasOwnProperty("email"))
        {object.email = message.email;}
        if (message.profile != null && message.hasOwnProperty("profile"))
        {object.profile = $root.ReviewerProfile.toObject(message.profile, options);}
        if (message.profileImage != null && message.hasOwnProperty("profileImage")) {
            object.profileImage = $root.CDNFile.toObject(message.profileImage, options);
            if (options.oneofs)
            {object._profileImage = "profileImage";}
        }
        if (message.socials != null && message.hasOwnProperty("socials")) {
            object.socials = $root.ReviewerSocials.toObject(message.socials, options);
            if (options.oneofs)
            {object._socials = "socials";}
        }
        if (message.isBlacklisted != null && message.hasOwnProperty("isBlacklisted")) {
            object.isBlacklisted = message.isBlacklisted;
            if (options.oneofs)
            {object._isBlacklisted = "isBlacklisted";}
        }
        if (message.blacklistedUntil != null && message.hasOwnProperty("blacklistedUntil")) {
            if (typeof message.blacklistedUntil === "number")
            {object.blacklistedUntil = options.longs === String ? String(message.blacklistedUntil) : message.blacklistedUntil;}
            else
            {object.blacklistedUntil = options.longs === String ? $util.Long.prototype.toString.call(message.blacklistedUntil) : options.longs === Number ? new $util.LongBits(message.blacklistedUntil.low >>> 0, message.blacklistedUntil.high >>> 0).toNumber() : message.blacklistedUntil;}
            if (options.oneofs)
            {object._blacklistedUntil = "blacklistedUntil";}
        }
        if (message.blacklistHistory && message.blacklistHistory.length) {
            object.blacklistHistory = [];
            for (let j = 0; j < message.blacklistHistory.length; ++j)
            {object.blacklistHistory[j] = $root.BlacklistHistoryRecord.toObject(message.blacklistHistory[j], options);}
        }
        if (message.note != null && message.hasOwnProperty("note")) {
            object.note = $root.ReviewerNote.toObject(message.note, options);
            if (options.oneofs)
            {object._note = "note";}
        }
        if (message.totalApplicationsCount != null && message.hasOwnProperty("totalApplicationsCount")) {
            object.totalApplicationsCount = message.totalApplicationsCount;
            if (options.oneofs)
            {object._totalApplicationsCount = "totalApplicationsCount";}
        }
        if (message.selectedApplicationsCount != null && message.hasOwnProperty("selectedApplicationsCount")) {
            object.selectedApplicationsCount = message.selectedApplicationsCount;
            if (options.oneofs)
            {object._selectedApplicationsCount = "selectedApplicationsCount";}
        }
        if (message.alternateApplicationsCount != null && message.hasOwnProperty("alternateApplicationsCount")) {
            object.alternateApplicationsCount = message.alternateApplicationsCount;
            if (options.oneofs)
            {object._alternateApplicationsCount = "alternateApplicationsCount";}
        }
        if (message.rejectedApplicationsCount != null && message.hasOwnProperty("rejectedApplicationsCount")) {
            object.rejectedApplicationsCount = message.rejectedApplicationsCount;
            if (options.oneofs)
            {object._rejectedApplicationsCount = "rejectedApplicationsCount";}
        }
        if (message.applicationsHistory && message.applicationsHistory.length) {
            object.applicationsHistory = [];
            for (let j = 0; j < message.applicationsHistory.length; ++j)
            {object.applicationsHistory[j] = $root.ReviewerApplicationsHistoryRecord.toObject(message.applicationsHistory[j], options);}
        }
        if (message.clientCounts != null && message.hasOwnProperty("clientCounts")) {
            object.clientCounts = $root.ReviewerClientCount.toObject(message.clientCounts, options);
            if (options.oneofs)
            {object._clientCounts = "clientCounts";}
        }
        return object;
    };

    /**
     * Converts this Reviewer to JSON.
     * @function toJSON
     * @memberof Reviewer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Reviewer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Reviewer
     * @function getTypeUrl
     * @memberof Reviewer
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Reviewer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Reviewer";
    };

    return Reviewer;
})();

export const ReviewerProfile = $root.ReviewerProfile = (() => {

    /**
     * Properties of a ReviewerProfile.
     * @exports IReviewerProfile
     * @interface IReviewerProfile
     * @property {string|null} [firstName] ReviewerProfile firstName
     * @property {string|null} [lastName] ReviewerProfile lastName
     * @property {ReviewerGender|null} [gender] ReviewerProfile gender
     * @property {number|Long|null} [birthDate] ReviewerProfile birthDate
     * @property {string|null} [phoneNumber] ReviewerProfile phoneNumber
     * @property {IAddress|null} [address] ReviewerProfile address
     * @property {number|null} [age] ReviewerProfile age
     */

    /**
     * Constructs a new ReviewerProfile.
     * @exports ReviewerProfile
     * @classdesc Represents a ReviewerProfile.
     * @implements IReviewerProfile
     * @constructor
     * @param {IReviewerProfile=} [properties] Properties to set
     */
    function ReviewerProfile(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * ReviewerProfile firstName.
     * @member {string} firstName
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.firstName = "";

    /**
     * ReviewerProfile lastName.
     * @member {string} lastName
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.lastName = "";

    /**
     * ReviewerProfile gender.
     * @member {ReviewerGender} gender
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.gender = 1;

    /**
     * ReviewerProfile birthDate.
     * @member {number|Long|null|undefined} birthDate
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.birthDate = null;

    /**
     * ReviewerProfile phoneNumber.
     * @member {string} phoneNumber
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.phoneNumber = "";

    /**
     * ReviewerProfile address.
     * @member {IAddress|null|undefined} address
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.address = null;

    /**
     * ReviewerProfile age.
     * @member {number|null|undefined} age
     * @memberof ReviewerProfile
     * @instance
     */
    ReviewerProfile.prototype.age = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ReviewerProfile _birthDate.
     * @member {"birthDate"|undefined} _birthDate
     * @memberof ReviewerProfile
     * @instance
     */
    Object.defineProperty(ReviewerProfile.prototype, "_birthDate", {
        get: $util.oneOfGetter($oneOfFields = ["birthDate"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerProfile _age.
     * @member {"age"|undefined} _age
     * @memberof ReviewerProfile
     * @instance
     */
    Object.defineProperty(ReviewerProfile.prototype, "_age", {
        get: $util.oneOfGetter($oneOfFields = ["age"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new ReviewerProfile instance using the specified properties.
     * @function create
     * @memberof ReviewerProfile
     * @static
     * @param {IReviewerProfile=} [properties] Properties to set
     * @returns {ReviewerProfile} ReviewerProfile instance
     */
    ReviewerProfile.create = function create(properties) {
        return new ReviewerProfile(properties);
    };

    /**
     * Encodes the specified ReviewerProfile message. Does not implicitly {@link ReviewerProfile.verify|verify} messages.
     * @function encode
     * @memberof ReviewerProfile
     * @static
     * @param {IReviewerProfile} message ReviewerProfile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerProfile.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);}
        if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);}
        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
        {writer.uint32(/* id 3, wireType 0 =*/24).int32(message.gender);}
        if (message.birthDate != null && Object.hasOwnProperty.call(message, "birthDate"))
        {writer.uint32(/* id 4, wireType 0 =*/32).sint64(message.birthDate);}
        if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
        {writer.uint32(/* id 5, wireType 2 =*/42).string(message.phoneNumber);}
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
        {$root.Address.encode(message.address, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();}
        if (message.age != null && Object.hasOwnProperty.call(message, "age"))
        {writer.uint32(/* id 7, wireType 0 =*/56).int32(message.age);}
        return writer;
    };

    /**
     * Encodes the specified ReviewerProfile message, length delimited. Does not implicitly {@link ReviewerProfile.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReviewerProfile
     * @static
     * @param {IReviewerProfile} message ReviewerProfile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerProfile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReviewerProfile message from the specified reader or buffer.
     * @function decode
     * @memberof ReviewerProfile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReviewerProfile} ReviewerProfile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerProfile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReviewerProfile();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.firstName = reader.string();
                break;
            }
            case 2: {
                message.lastName = reader.string();
                break;
            }
            case 3: {
                message.gender = reader.int32();
                break;
            }
            case 4: {
                message.birthDate = reader.sint64();
                break;
            }
            case 5: {
                message.phoneNumber = reader.string();
                break;
            }
            case 6: {
                message.address = $root.Address.decode(reader, reader.uint32());
                break;
            }
            case 7: {
                message.age = reader.int32();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReviewerProfile message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReviewerProfile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReviewerProfile} ReviewerProfile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerProfile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReviewerProfile message.
     * @function verify
     * @memberof ReviewerProfile
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReviewerProfile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.firstName != null && message.hasOwnProperty("firstName"))
        {if (!$util.isString(message.firstName))
        {return "firstName: string expected";}}
        if (message.lastName != null && message.hasOwnProperty("lastName"))
        {if (!$util.isString(message.lastName))
        {return "lastName: string expected";}}
        if (message.gender != null && message.hasOwnProperty("gender"))
        {switch (message.gender) {
        default:
            return "gender: enum value expected";
        case 1:
        case 2:
        case 3:
            break;
        }}
        if (message.birthDate != null && message.hasOwnProperty("birthDate")) {
            properties._birthDate = 1;
            if (!$util.isInteger(message.birthDate) && !(message.birthDate && $util.isInteger(message.birthDate.low) && $util.isInteger(message.birthDate.high)))
            {return "birthDate: integer|Long expected";}
        }
        if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
        {if (!$util.isString(message.phoneNumber))
        {return "phoneNumber: string expected";}}
        if (message.address != null && message.hasOwnProperty("address")) {
            let error = $root.Address.verify(message.address);
            if (error)
            {return "address." + error;}
        }
        if (message.age != null && message.hasOwnProperty("age")) {
            properties._age = 1;
            if (!$util.isInteger(message.age))
            {return "age: integer expected";}
        }
        return null;
    };

    /**
     * Creates a ReviewerProfile message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReviewerProfile
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReviewerProfile} ReviewerProfile
     */
    ReviewerProfile.fromObject = function fromObject(object) {
        if (object instanceof $root.ReviewerProfile)
        {return object;}
        let message = new $root.ReviewerProfile();
        if (object.firstName != null)
        {message.firstName = String(object.firstName);}
        if (object.lastName != null)
        {message.lastName = String(object.lastName);}
        switch (object.gender) {
        default:
            if (typeof object.gender === "number") {
                message.gender = object.gender;
                break;
            }
            break;
        case "male":
        case 1:
            message.gender = 1;
            break;
        case "female":
        case 2:
            message.gender = 2;
            break;
        case "other":
        case 3:
            message.gender = 3;
            break;
        }
        if (object.birthDate != null)
        {if ($util.Long)
        {(message.birthDate = $util.Long.fromValue(object.birthDate)).unsigned = false;}
        else if (typeof object.birthDate === "string")
        {message.birthDate = parseInt(object.birthDate, 10);}
        else if (typeof object.birthDate === "number")
        {message.birthDate = object.birthDate;}
        else if (typeof object.birthDate === "object")
        {message.birthDate = new $util.LongBits(object.birthDate.low >>> 0, object.birthDate.high >>> 0).toNumber();}}
        if (object.phoneNumber != null)
        {message.phoneNumber = String(object.phoneNumber);}
        if (object.address != null) {
            if (typeof object.address !== "object")
            {throw TypeError(".ReviewerProfile.address: object expected");}
            message.address = $root.Address.fromObject(object.address);
        }
        if (object.age != null)
        {message.age = object.age | 0;}
        return message;
    };

    /**
     * Creates a plain object from a ReviewerProfile message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReviewerProfile
     * @static
     * @param {ReviewerProfile} message ReviewerProfile
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReviewerProfile.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults) {
            object.firstName = "";
            object.lastName = "";
            object.gender = options.enums === String ? "male" : 1;
            object.phoneNumber = "";
            object.address = null;
        }
        if (message.firstName != null && message.hasOwnProperty("firstName"))
        {object.firstName = message.firstName;}
        if (message.lastName != null && message.hasOwnProperty("lastName"))
        {object.lastName = message.lastName;}
        if (message.gender != null && message.hasOwnProperty("gender"))
        {object.gender = options.enums === String ? $root.ReviewerGender[message.gender] === undefined ? message.gender : $root.ReviewerGender[message.gender] : message.gender;}
        if (message.birthDate != null && message.hasOwnProperty("birthDate")) {
            if (typeof message.birthDate === "number")
            {object.birthDate = options.longs === String ? String(message.birthDate) : message.birthDate;}
            else
            {object.birthDate = options.longs === String ? $util.Long.prototype.toString.call(message.birthDate) : options.longs === Number ? new $util.LongBits(message.birthDate.low >>> 0, message.birthDate.high >>> 0).toNumber() : message.birthDate;}
            if (options.oneofs)
            {object._birthDate = "birthDate";}
        }
        if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
        {object.phoneNumber = message.phoneNumber;}
        if (message.address != null && message.hasOwnProperty("address"))
        {object.address = $root.Address.toObject(message.address, options);}
        if (message.age != null && message.hasOwnProperty("age")) {
            object.age = message.age;
            if (options.oneofs)
            {object._age = "age";}
        }
        return object;
    };

    /**
     * Converts this ReviewerProfile to JSON.
     * @function toJSON
     * @memberof ReviewerProfile
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReviewerProfile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReviewerProfile
     * @function getTypeUrl
     * @memberof ReviewerProfile
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReviewerProfile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReviewerProfile";
    };

    return ReviewerProfile;
})();

export const ReviewerSocials = $root.ReviewerSocials = (() => {

    /**
     * Properties of a ReviewerSocials.
     * @exports IReviewerSocials
     * @interface IReviewerSocials
     * @property {boolean|null} [hasFb] ReviewerSocials hasFb
     * @property {number|null} [fbFollowers] ReviewerSocials fbFollowers
     * @property {string|null} [fbUrl] ReviewerSocials fbUrl
     * @property {boolean|null} [hasIg] ReviewerSocials hasIg
     * @property {number|null} [igFollowers] ReviewerSocials igFollowers
     * @property {string|null} [igUrl] ReviewerSocials igUrl
     */

    /**
     * Constructs a new ReviewerSocials.
     * @exports ReviewerSocials
     * @classdesc Represents a ReviewerSocials.
     * @implements IReviewerSocials
     * @constructor
     * @param {IReviewerSocials=} [properties] Properties to set
     */
    function ReviewerSocials(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * ReviewerSocials hasFb.
     * @member {boolean|null|undefined} hasFb
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.hasFb = null;

    /**
     * ReviewerSocials fbFollowers.
     * @member {number|null|undefined} fbFollowers
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.fbFollowers = null;

    /**
     * ReviewerSocials fbUrl.
     * @member {string|null|undefined} fbUrl
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.fbUrl = null;

    /**
     * ReviewerSocials hasIg.
     * @member {boolean|null|undefined} hasIg
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.hasIg = null;

    /**
     * ReviewerSocials igFollowers.
     * @member {number|null|undefined} igFollowers
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.igFollowers = null;

    /**
     * ReviewerSocials igUrl.
     * @member {string|null|undefined} igUrl
     * @memberof ReviewerSocials
     * @instance
     */
    ReviewerSocials.prototype.igUrl = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ReviewerSocials _hasFb.
     * @member {"hasFb"|undefined} _hasFb
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_hasFb", {
        get: $util.oneOfGetter($oneOfFields = ["hasFb"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerSocials _fbFollowers.
     * @member {"fbFollowers"|undefined} _fbFollowers
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_fbFollowers", {
        get: $util.oneOfGetter($oneOfFields = ["fbFollowers"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerSocials _fbUrl.
     * @member {"fbUrl"|undefined} _fbUrl
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_fbUrl", {
        get: $util.oneOfGetter($oneOfFields = ["fbUrl"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerSocials _hasIg.
     * @member {"hasIg"|undefined} _hasIg
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_hasIg", {
        get: $util.oneOfGetter($oneOfFields = ["hasIg"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerSocials _igFollowers.
     * @member {"igFollowers"|undefined} _igFollowers
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_igFollowers", {
        get: $util.oneOfGetter($oneOfFields = ["igFollowers"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerSocials _igUrl.
     * @member {"igUrl"|undefined} _igUrl
     * @memberof ReviewerSocials
     * @instance
     */
    Object.defineProperty(ReviewerSocials.prototype, "_igUrl", {
        get: $util.oneOfGetter($oneOfFields = ["igUrl"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new ReviewerSocials instance using the specified properties.
     * @function create
     * @memberof ReviewerSocials
     * @static
     * @param {IReviewerSocials=} [properties] Properties to set
     * @returns {ReviewerSocials} ReviewerSocials instance
     */
    ReviewerSocials.create = function create(properties) {
        return new ReviewerSocials(properties);
    };

    /**
     * Encodes the specified ReviewerSocials message. Does not implicitly {@link ReviewerSocials.verify|verify} messages.
     * @function encode
     * @memberof ReviewerSocials
     * @static
     * @param {IReviewerSocials} message ReviewerSocials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerSocials.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.hasFb != null && Object.hasOwnProperty.call(message, "hasFb"))
        {writer.uint32(/* id 1, wireType 0 =*/8).bool(message.hasFb);}
        if (message.fbFollowers != null && Object.hasOwnProperty.call(message, "fbFollowers"))
        {writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.fbFollowers);}
        if (message.fbUrl != null && Object.hasOwnProperty.call(message, "fbUrl"))
        {writer.uint32(/* id 3, wireType 2 =*/26).string(message.fbUrl);}
        if (message.hasIg != null && Object.hasOwnProperty.call(message, "hasIg"))
        {writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hasIg);}
        if (message.igFollowers != null && Object.hasOwnProperty.call(message, "igFollowers"))
        {writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.igFollowers);}
        if (message.igUrl != null && Object.hasOwnProperty.call(message, "igUrl"))
        {writer.uint32(/* id 6, wireType 2 =*/50).string(message.igUrl);}
        return writer;
    };

    /**
     * Encodes the specified ReviewerSocials message, length delimited. Does not implicitly {@link ReviewerSocials.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReviewerSocials
     * @static
     * @param {IReviewerSocials} message ReviewerSocials message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerSocials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReviewerSocials message from the specified reader or buffer.
     * @function decode
     * @memberof ReviewerSocials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReviewerSocials} ReviewerSocials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerSocials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReviewerSocials();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.hasFb = reader.bool();
                break;
            }
            case 2: {
                message.fbFollowers = reader.uint32();
                break;
            }
            case 3: {
                message.fbUrl = reader.string();
                break;
            }
            case 4: {
                message.hasIg = reader.bool();
                break;
            }
            case 5: {
                message.igFollowers = reader.uint32();
                break;
            }
            case 6: {
                message.igUrl = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReviewerSocials message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReviewerSocials
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReviewerSocials} ReviewerSocials
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerSocials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReviewerSocials message.
     * @function verify
     * @memberof ReviewerSocials
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReviewerSocials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.hasFb != null && message.hasOwnProperty("hasFb")) {
            properties._hasFb = 1;
            if (typeof message.hasFb !== "boolean")
            {return "hasFb: boolean expected";}
        }
        if (message.fbFollowers != null && message.hasOwnProperty("fbFollowers")) {
            properties._fbFollowers = 1;
            if (!$util.isInteger(message.fbFollowers))
            {return "fbFollowers: integer expected";}
        }
        if (message.fbUrl != null && message.hasOwnProperty("fbUrl")) {
            properties._fbUrl = 1;
            if (!$util.isString(message.fbUrl))
            {return "fbUrl: string expected";}
        }
        if (message.hasIg != null && message.hasOwnProperty("hasIg")) {
            properties._hasIg = 1;
            if (typeof message.hasIg !== "boolean")
            {return "hasIg: boolean expected";}
        }
        if (message.igFollowers != null && message.hasOwnProperty("igFollowers")) {
            properties._igFollowers = 1;
            if (!$util.isInteger(message.igFollowers))
            {return "igFollowers: integer expected";}
        }
        if (message.igUrl != null && message.hasOwnProperty("igUrl")) {
            properties._igUrl = 1;
            if (!$util.isString(message.igUrl))
            {return "igUrl: string expected";}
        }
        return null;
    };

    /**
     * Creates a ReviewerSocials message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReviewerSocials
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReviewerSocials} ReviewerSocials
     */
    ReviewerSocials.fromObject = function fromObject(object) {
        if (object instanceof $root.ReviewerSocials)
        {return object;}
        let message = new $root.ReviewerSocials();
        if (object.hasFb != null)
        {message.hasFb = Boolean(object.hasFb);}
        if (object.fbFollowers != null)
        {message.fbFollowers = object.fbFollowers >>> 0;}
        if (object.fbUrl != null)
        {message.fbUrl = String(object.fbUrl);}
        if (object.hasIg != null)
        {message.hasIg = Boolean(object.hasIg);}
        if (object.igFollowers != null)
        {message.igFollowers = object.igFollowers >>> 0;}
        if (object.igUrl != null)
        {message.igUrl = String(object.igUrl);}
        return message;
    };

    /**
     * Creates a plain object from a ReviewerSocials message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReviewerSocials
     * @static
     * @param {ReviewerSocials} message ReviewerSocials
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReviewerSocials.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.hasFb != null && message.hasOwnProperty("hasFb")) {
            object.hasFb = message.hasFb;
            if (options.oneofs)
            {object._hasFb = "hasFb";}
        }
        if (message.fbFollowers != null && message.hasOwnProperty("fbFollowers")) {
            object.fbFollowers = message.fbFollowers;
            if (options.oneofs)
            {object._fbFollowers = "fbFollowers";}
        }
        if (message.fbUrl != null && message.hasOwnProperty("fbUrl")) {
            object.fbUrl = message.fbUrl;
            if (options.oneofs)
            {object._fbUrl = "fbUrl";}
        }
        if (message.hasIg != null && message.hasOwnProperty("hasIg")) {
            object.hasIg = message.hasIg;
            if (options.oneofs)
            {object._hasIg = "hasIg";}
        }
        if (message.igFollowers != null && message.hasOwnProperty("igFollowers")) {
            object.igFollowers = message.igFollowers;
            if (options.oneofs)
            {object._igFollowers = "igFollowers";}
        }
        if (message.igUrl != null && message.hasOwnProperty("igUrl")) {
            object.igUrl = message.igUrl;
            if (options.oneofs)
            {object._igUrl = "igUrl";}
        }
        return object;
    };

    /**
     * Converts this ReviewerSocials to JSON.
     * @function toJSON
     * @memberof ReviewerSocials
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReviewerSocials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReviewerSocials
     * @function getTypeUrl
     * @memberof ReviewerSocials
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReviewerSocials.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReviewerSocials";
    };

    return ReviewerSocials;
})();

export const ReviewerNote = $root.ReviewerNote = (() => {

    /**
     * Properties of a ReviewerNote.
     * @exports IReviewerNote
     * @interface IReviewerNote
     * @property {string|null} [content] ReviewerNote content
     */

    /**
     * Constructs a new ReviewerNote.
     * @exports ReviewerNote
     * @classdesc Represents a ReviewerNote.
     * @implements IReviewerNote
     * @constructor
     * @param {IReviewerNote=} [properties] Properties to set
     */
    function ReviewerNote(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * ReviewerNote content.
     * @member {string} content
     * @memberof ReviewerNote
     * @instance
     */
    ReviewerNote.prototype.content = "";

    /**
     * Creates a new ReviewerNote instance using the specified properties.
     * @function create
     * @memberof ReviewerNote
     * @static
     * @param {IReviewerNote=} [properties] Properties to set
     * @returns {ReviewerNote} ReviewerNote instance
     */
    ReviewerNote.create = function create(properties) {
        return new ReviewerNote(properties);
    };

    /**
     * Encodes the specified ReviewerNote message. Does not implicitly {@link ReviewerNote.verify|verify} messages.
     * @function encode
     * @memberof ReviewerNote
     * @static
     * @param {IReviewerNote} message ReviewerNote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerNote.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.content);}
        return writer;
    };

    /**
     * Encodes the specified ReviewerNote message, length delimited. Does not implicitly {@link ReviewerNote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReviewerNote
     * @static
     * @param {IReviewerNote} message ReviewerNote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerNote.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReviewerNote message from the specified reader or buffer.
     * @function decode
     * @memberof ReviewerNote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReviewerNote} ReviewerNote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerNote.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReviewerNote();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.content = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReviewerNote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReviewerNote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReviewerNote} ReviewerNote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerNote.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReviewerNote message.
     * @function verify
     * @memberof ReviewerNote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReviewerNote.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        if (message.content != null && message.hasOwnProperty("content"))
        {if (!$util.isString(message.content))
        {return "content: string expected";}}
        return null;
    };

    /**
     * Creates a ReviewerNote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReviewerNote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReviewerNote} ReviewerNote
     */
    ReviewerNote.fromObject = function fromObject(object) {
        if (object instanceof $root.ReviewerNote)
        {return object;}
        let message = new $root.ReviewerNote();
        if (object.content != null)
        {message.content = String(object.content);}
        return message;
    };

    /**
     * Creates a plain object from a ReviewerNote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReviewerNote
     * @static
     * @param {ReviewerNote} message ReviewerNote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReviewerNote.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults)
        {object.content = "";}
        if (message.content != null && message.hasOwnProperty("content"))
        {object.content = message.content;}
        return object;
    };

    /**
     * Converts this ReviewerNote to JSON.
     * @function toJSON
     * @memberof ReviewerNote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReviewerNote.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReviewerNote
     * @function getTypeUrl
     * @memberof ReviewerNote
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReviewerNote.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReviewerNote";
    };

    return ReviewerNote;
})();

export const BlacklistHistoryRecord = $root.BlacklistHistoryRecord = (() => {

    /**
     * Properties of a BlacklistHistoryRecord.
     * @exports IBlacklistHistoryRecord
     * @interface IBlacklistHistoryRecord
     * @property {IUser|null} [performedBy] BlacklistHistoryRecord performedBy
     * @property {number|Long|null} [performedAt] BlacklistHistoryRecord performedAt
     * @property {string|null} [action] BlacklistHistoryRecord action
     * @property {number|null} [durationHours] BlacklistHistoryRecord durationHours
     * @property {string|null} [reason] BlacklistHistoryRecord reason
     * @property {string|null} [message] BlacklistHistoryRecord message
     */

    /**
     * Constructs a new BlacklistHistoryRecord.
     * @exports BlacklistHistoryRecord
     * @classdesc Represents a BlacklistHistoryRecord.
     * @implements IBlacklistHistoryRecord
     * @constructor
     * @param {IBlacklistHistoryRecord=} [properties] Properties to set
     */
    function BlacklistHistoryRecord(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * BlacklistHistoryRecord performedBy.
     * @member {IUser|null|undefined} performedBy
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.performedBy = null;

    /**
     * BlacklistHistoryRecord performedAt.
     * @member {number|Long|null|undefined} performedAt
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.performedAt = null;

    /**
     * BlacklistHistoryRecord action.
     * @member {string|null|undefined} action
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.action = null;

    /**
     * BlacklistHistoryRecord durationHours.
     * @member {number|null|undefined} durationHours
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.durationHours = null;

    /**
     * BlacklistHistoryRecord reason.
     * @member {string|null|undefined} reason
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.reason = null;

    /**
     * BlacklistHistoryRecord message.
     * @member {string|null|undefined} message
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    BlacklistHistoryRecord.prototype.message = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * BlacklistHistoryRecord _performedBy.
     * @member {"performedBy"|undefined} _performedBy
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_performedBy", {
        get: $util.oneOfGetter($oneOfFields = ["performedBy"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * BlacklistHistoryRecord _performedAt.
     * @member {"performedAt"|undefined} _performedAt
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_performedAt", {
        get: $util.oneOfGetter($oneOfFields = ["performedAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * BlacklistHistoryRecord _action.
     * @member {"action"|undefined} _action
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_action", {
        get: $util.oneOfGetter($oneOfFields = ["action"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * BlacklistHistoryRecord _durationHours.
     * @member {"durationHours"|undefined} _durationHours
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_durationHours", {
        get: $util.oneOfGetter($oneOfFields = ["durationHours"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * BlacklistHistoryRecord _reason.
     * @member {"reason"|undefined} _reason
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_reason", {
        get: $util.oneOfGetter($oneOfFields = ["reason"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * BlacklistHistoryRecord _message.
     * @member {"message"|undefined} _message
     * @memberof BlacklistHistoryRecord
     * @instance
     */
    Object.defineProperty(BlacklistHistoryRecord.prototype, "_message", {
        get: $util.oneOfGetter($oneOfFields = ["message"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new BlacklistHistoryRecord instance using the specified properties.
     * @function create
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {IBlacklistHistoryRecord=} [properties] Properties to set
     * @returns {BlacklistHistoryRecord} BlacklistHistoryRecord instance
     */
    BlacklistHistoryRecord.create = function create(properties) {
        return new BlacklistHistoryRecord(properties);
    };

    /**
     * Encodes the specified BlacklistHistoryRecord message. Does not implicitly {@link BlacklistHistoryRecord.verify|verify} messages.
     * @function encode
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {IBlacklistHistoryRecord} message BlacklistHistoryRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlacklistHistoryRecord.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.performedBy != null && Object.hasOwnProperty.call(message, "performedBy"))
        {$root.User.encode(message.performedBy, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();}
        if (message.performedAt != null && Object.hasOwnProperty.call(message, "performedAt"))
        {writer.uint32(/* id 2, wireType 0 =*/16).int64(message.performedAt);}
        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
        {writer.uint32(/* id 3, wireType 2 =*/26).string(message.action);}
        if (message.durationHours != null && Object.hasOwnProperty.call(message, "durationHours"))
        {writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.durationHours);}
        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
        {writer.uint32(/* id 5, wireType 2 =*/42).string(message.reason);}
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
        {writer.uint32(/* id 6, wireType 2 =*/50).string(message.message);}
        return writer;
    };

    /**
     * Encodes the specified BlacklistHistoryRecord message, length delimited. Does not implicitly {@link BlacklistHistoryRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {IBlacklistHistoryRecord} message BlacklistHistoryRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlacklistHistoryRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BlacklistHistoryRecord message from the specified reader or buffer.
     * @function decode
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BlacklistHistoryRecord} BlacklistHistoryRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlacklistHistoryRecord.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlacklistHistoryRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.performedBy = $root.User.decode(reader, reader.uint32());
                break;
            }
            case 2: {
                message.performedAt = reader.int64();
                break;
            }
            case 3: {
                message.action = reader.string();
                break;
            }
            case 4: {
                message.durationHours = reader.uint32();
                break;
            }
            case 5: {
                message.reason = reader.string();
                break;
            }
            case 6: {
                message.message = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BlacklistHistoryRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BlacklistHistoryRecord} BlacklistHistoryRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlacklistHistoryRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BlacklistHistoryRecord message.
     * @function verify
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BlacklistHistoryRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.performedBy != null && message.hasOwnProperty("performedBy")) {
            properties._performedBy = 1;
            {
                let error = $root.User.verify(message.performedBy);
                if (error)
                {return "performedBy." + error;}
            }
        }
        if (message.performedAt != null && message.hasOwnProperty("performedAt")) {
            properties._performedAt = 1;
            if (!$util.isInteger(message.performedAt) && !(message.performedAt && $util.isInteger(message.performedAt.low) && $util.isInteger(message.performedAt.high)))
            {return "performedAt: integer|Long expected";}
        }
        if (message.action != null && message.hasOwnProperty("action")) {
            properties._action = 1;
            if (!$util.isString(message.action))
            {return "action: string expected";}
        }
        if (message.durationHours != null && message.hasOwnProperty("durationHours")) {
            properties._durationHours = 1;
            if (!$util.isInteger(message.durationHours))
            {return "durationHours: integer expected";}
        }
        if (message.reason != null && message.hasOwnProperty("reason")) {
            properties._reason = 1;
            if (!$util.isString(message.reason))
            {return "reason: string expected";}
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            properties._message = 1;
            if (!$util.isString(message.message))
            {return "message: string expected";}
        }
        return null;
    };

    /**
     * Creates a BlacklistHistoryRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BlacklistHistoryRecord} BlacklistHistoryRecord
     */
    BlacklistHistoryRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.BlacklistHistoryRecord)
        {return object;}
        let message = new $root.BlacklistHistoryRecord();
        if (object.performedBy != null) {
            if (typeof object.performedBy !== "object")
            {throw TypeError(".BlacklistHistoryRecord.performedBy: object expected");}
            message.performedBy = $root.User.fromObject(object.performedBy);
        }
        if (object.performedAt != null)
        {if ($util.Long)
        {(message.performedAt = $util.Long.fromValue(object.performedAt)).unsigned = false;}
        else if (typeof object.performedAt === "string")
        {message.performedAt = parseInt(object.performedAt, 10);}
        else if (typeof object.performedAt === "number")
        {message.performedAt = object.performedAt;}
        else if (typeof object.performedAt === "object")
        {message.performedAt = new $util.LongBits(object.performedAt.low >>> 0, object.performedAt.high >>> 0).toNumber();}}
        if (object.action != null)
        {message.action = String(object.action);}
        if (object.durationHours != null)
        {message.durationHours = object.durationHours >>> 0;}
        if (object.reason != null)
        {message.reason = String(object.reason);}
        if (object.message != null)
        {message.message = String(object.message);}
        return message;
    };

    /**
     * Creates a plain object from a BlacklistHistoryRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {BlacklistHistoryRecord} message BlacklistHistoryRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BlacklistHistoryRecord.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.performedBy != null && message.hasOwnProperty("performedBy")) {
            object.performedBy = $root.User.toObject(message.performedBy, options);
            if (options.oneofs)
            {object._performedBy = "performedBy";}
        }
        if (message.performedAt != null && message.hasOwnProperty("performedAt")) {
            if (typeof message.performedAt === "number")
            {object.performedAt = options.longs === String ? String(message.performedAt) : message.performedAt;}
            else
            {object.performedAt = options.longs === String ? $util.Long.prototype.toString.call(message.performedAt) : options.longs === Number ? new $util.LongBits(message.performedAt.low >>> 0, message.performedAt.high >>> 0).toNumber() : message.performedAt;}
            if (options.oneofs)
            {object._performedAt = "performedAt";}
        }
        if (message.action != null && message.hasOwnProperty("action")) {
            object.action = message.action;
            if (options.oneofs)
            {object._action = "action";}
        }
        if (message.durationHours != null && message.hasOwnProperty("durationHours")) {
            object.durationHours = message.durationHours;
            if (options.oneofs)
            {object._durationHours = "durationHours";}
        }
        if (message.reason != null && message.hasOwnProperty("reason")) {
            object.reason = message.reason;
            if (options.oneofs)
            {object._reason = "reason";}
        }
        if (message.message != null && message.hasOwnProperty("message")) {
            object.message = message.message;
            if (options.oneofs)
            {object._message = "message";}
        }
        return object;
    };

    /**
     * Converts this BlacklistHistoryRecord to JSON.
     * @function toJSON
     * @memberof BlacklistHistoryRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BlacklistHistoryRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BlacklistHistoryRecord
     * @function getTypeUrl
     * @memberof BlacklistHistoryRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BlacklistHistoryRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BlacklistHistoryRecord";
    };

    return BlacklistHistoryRecord;
})();

export const ReviewerApplicationsHistoryRecord = $root.ReviewerApplicationsHistoryRecord = (() => {

    /**
     * Properties of a ReviewerApplicationsHistoryRecord.
     * @exports IReviewerApplicationsHistoryRecord
     * @interface IReviewerApplicationsHistoryRecord
     * @property {ICampaign|null} [campaign] ReviewerApplicationsHistoryRecord campaign
     * @property {CampaignApplicationResolutionStatus|null} [status] ReviewerApplicationsHistoryRecord status
     * @property {number|Long|null} [resolvedAt] ReviewerApplicationsHistoryRecord resolvedAt
     */

    /**
     * Constructs a new ReviewerApplicationsHistoryRecord.
     * @exports ReviewerApplicationsHistoryRecord
     * @classdesc Represents a ReviewerApplicationsHistoryRecord.
     * @implements IReviewerApplicationsHistoryRecord
     * @constructor
     * @param {IReviewerApplicationsHistoryRecord=} [properties] Properties to set
     */
    function ReviewerApplicationsHistoryRecord(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * ReviewerApplicationsHistoryRecord campaign.
     * @member {ICampaign|null|undefined} campaign
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    ReviewerApplicationsHistoryRecord.prototype.campaign = null;

    /**
     * ReviewerApplicationsHistoryRecord status.
     * @member {CampaignApplicationResolutionStatus|null|undefined} status
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    ReviewerApplicationsHistoryRecord.prototype.status = null;

    /**
     * ReviewerApplicationsHistoryRecord resolvedAt.
     * @member {number|Long|null|undefined} resolvedAt
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    ReviewerApplicationsHistoryRecord.prototype.resolvedAt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ReviewerApplicationsHistoryRecord _campaign.
     * @member {"campaign"|undefined} _campaign
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    Object.defineProperty(ReviewerApplicationsHistoryRecord.prototype, "_campaign", {
        get: $util.oneOfGetter($oneOfFields = ["campaign"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerApplicationsHistoryRecord _status.
     * @member {"status"|undefined} _status
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    Object.defineProperty(ReviewerApplicationsHistoryRecord.prototype, "_status", {
        get: $util.oneOfGetter($oneOfFields = ["status"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerApplicationsHistoryRecord _resolvedAt.
     * @member {"resolvedAt"|undefined} _resolvedAt
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     */
    Object.defineProperty(ReviewerApplicationsHistoryRecord.prototype, "_resolvedAt", {
        get: $util.oneOfGetter($oneOfFields = ["resolvedAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new ReviewerApplicationsHistoryRecord instance using the specified properties.
     * @function create
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {IReviewerApplicationsHistoryRecord=} [properties] Properties to set
     * @returns {ReviewerApplicationsHistoryRecord} ReviewerApplicationsHistoryRecord instance
     */
    ReviewerApplicationsHistoryRecord.create = function create(properties) {
        return new ReviewerApplicationsHistoryRecord(properties);
    };

    /**
     * Encodes the specified ReviewerApplicationsHistoryRecord message. Does not implicitly {@link ReviewerApplicationsHistoryRecord.verify|verify} messages.
     * @function encode
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {IReviewerApplicationsHistoryRecord} message ReviewerApplicationsHistoryRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerApplicationsHistoryRecord.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
        {$root.Campaign.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();}
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        {writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);}
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
        {writer.uint32(/* id 3, wireType 0 =*/24).int64(message.resolvedAt);}
        return writer;
    };

    /**
     * Encodes the specified ReviewerApplicationsHistoryRecord message, length delimited. Does not implicitly {@link ReviewerApplicationsHistoryRecord.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {IReviewerApplicationsHistoryRecord} message ReviewerApplicationsHistoryRecord message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerApplicationsHistoryRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReviewerApplicationsHistoryRecord message from the specified reader or buffer.
     * @function decode
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReviewerApplicationsHistoryRecord} ReviewerApplicationsHistoryRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerApplicationsHistoryRecord.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReviewerApplicationsHistoryRecord();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.campaign = $root.Campaign.decode(reader, reader.uint32());
                break;
            }
            case 2: {
                message.status = reader.int32();
                break;
            }
            case 3: {
                message.resolvedAt = reader.int64();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReviewerApplicationsHistoryRecord message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReviewerApplicationsHistoryRecord} ReviewerApplicationsHistoryRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerApplicationsHistoryRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReviewerApplicationsHistoryRecord message.
     * @function verify
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReviewerApplicationsHistoryRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.campaign != null && message.hasOwnProperty("campaign")) {
            properties._campaign = 1;
            {
                let error = $root.Campaign.verify(message.campaign);
                if (error)
                {return "campaign." + error;}
            }
        }
        if (message.status != null && message.hasOwnProperty("status")) {
            properties._status = 1;
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
            }
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt")) {
            properties._resolvedAt = 1;
            if (!$util.isInteger(message.resolvedAt) && !(message.resolvedAt && $util.isInteger(message.resolvedAt.low) && $util.isInteger(message.resolvedAt.high)))
            {return "resolvedAt: integer|Long expected";}
        }
        return null;
    };

    /**
     * Creates a ReviewerApplicationsHistoryRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReviewerApplicationsHistoryRecord} ReviewerApplicationsHistoryRecord
     */
    ReviewerApplicationsHistoryRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.ReviewerApplicationsHistoryRecord)
        {return object;}
        let message = new $root.ReviewerApplicationsHistoryRecord();
        if (object.campaign != null) {
            if (typeof object.campaign !== "object")
            {throw TypeError(".ReviewerApplicationsHistoryRecord.campaign: object expected");}
            message.campaign = $root.Campaign.fromObject(object.campaign);
        }
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "selected":
        case 1:
            message.status = 1;
            break;
        case "alternate":
        case 2:
            message.status = 2;
            break;
        case "rejected":
        case 3:
            message.status = 3;
            break;
        }
        if (object.resolvedAt != null)
        {if ($util.Long)
        {(message.resolvedAt = $util.Long.fromValue(object.resolvedAt)).unsigned = false;}
        else if (typeof object.resolvedAt === "string")
        {message.resolvedAt = parseInt(object.resolvedAt, 10);}
        else if (typeof object.resolvedAt === "number")
        {message.resolvedAt = object.resolvedAt;}
        else if (typeof object.resolvedAt === "object")
        {message.resolvedAt = new $util.LongBits(object.resolvedAt.low >>> 0, object.resolvedAt.high >>> 0).toNumber();}}
        return message;
    };

    /**
     * Creates a plain object from a ReviewerApplicationsHistoryRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {ReviewerApplicationsHistoryRecord} message ReviewerApplicationsHistoryRecord
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReviewerApplicationsHistoryRecord.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.campaign != null && message.hasOwnProperty("campaign")) {
            object.campaign = $root.Campaign.toObject(message.campaign, options);
            if (options.oneofs)
            {object._campaign = "campaign";}
        }
        if (message.status != null && message.hasOwnProperty("status")) {
            object.status = options.enums === String ? $root.CampaignApplicationResolutionStatus[message.status] === undefined ? message.status : $root.CampaignApplicationResolutionStatus[message.status] : message.status;
            if (options.oneofs)
            {object._status = "status";}
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt")) {
            if (typeof message.resolvedAt === "number")
            {object.resolvedAt = options.longs === String ? String(message.resolvedAt) : message.resolvedAt;}
            else
            {object.resolvedAt = options.longs === String ? $util.Long.prototype.toString.call(message.resolvedAt) : options.longs === Number ? new $util.LongBits(message.resolvedAt.low >>> 0, message.resolvedAt.high >>> 0).toNumber() : message.resolvedAt;}
            if (options.oneofs)
            {object._resolvedAt = "resolvedAt";}
        }
        return object;
    };

    /**
     * Converts this ReviewerApplicationsHistoryRecord to JSON.
     * @function toJSON
     * @memberof ReviewerApplicationsHistoryRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReviewerApplicationsHistoryRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReviewerApplicationsHistoryRecord
     * @function getTypeUrl
     * @memberof ReviewerApplicationsHistoryRecord
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReviewerApplicationsHistoryRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReviewerApplicationsHistoryRecord";
    };

    return ReviewerApplicationsHistoryRecord;
})();

export const ReviewerClientCount = $root.ReviewerClientCount = (() => {

    /**
     * Properties of a ReviewerClientCount.
     * @exports IReviewerClientCount
     * @interface IReviewerClientCount
     * @property {number|null} [any] ReviewerClientCount any
     * @property {number|null} [selected] ReviewerClientCount selected
     * @property {number|null} [alternate] ReviewerClientCount alternate
     * @property {number|null} [rejected] ReviewerClientCount rejected
     */

    /**
     * Constructs a new ReviewerClientCount.
     * @exports ReviewerClientCount
     * @classdesc Represents a ReviewerClientCount.
     * @implements IReviewerClientCount
     * @constructor
     * @param {IReviewerClientCount=} [properties] Properties to set
     */
    function ReviewerClientCount(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * ReviewerClientCount any.
     * @member {number|null|undefined} any
     * @memberof ReviewerClientCount
     * @instance
     */
    ReviewerClientCount.prototype.any = null;

    /**
     * ReviewerClientCount selected.
     * @member {number|null|undefined} selected
     * @memberof ReviewerClientCount
     * @instance
     */
    ReviewerClientCount.prototype.selected = null;

    /**
     * ReviewerClientCount alternate.
     * @member {number|null|undefined} alternate
     * @memberof ReviewerClientCount
     * @instance
     */
    ReviewerClientCount.prototype.alternate = null;

    /**
     * ReviewerClientCount rejected.
     * @member {number|null|undefined} rejected
     * @memberof ReviewerClientCount
     * @instance
     */
    ReviewerClientCount.prototype.rejected = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ReviewerClientCount _any.
     * @member {"any"|undefined} _any
     * @memberof ReviewerClientCount
     * @instance
     */
    Object.defineProperty(ReviewerClientCount.prototype, "_any", {
        get: $util.oneOfGetter($oneOfFields = ["any"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerClientCount _selected.
     * @member {"selected"|undefined} _selected
     * @memberof ReviewerClientCount
     * @instance
     */
    Object.defineProperty(ReviewerClientCount.prototype, "_selected", {
        get: $util.oneOfGetter($oneOfFields = ["selected"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerClientCount _alternate.
     * @member {"alternate"|undefined} _alternate
     * @memberof ReviewerClientCount
     * @instance
     */
    Object.defineProperty(ReviewerClientCount.prototype, "_alternate", {
        get: $util.oneOfGetter($oneOfFields = ["alternate"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * ReviewerClientCount _rejected.
     * @member {"rejected"|undefined} _rejected
     * @memberof ReviewerClientCount
     * @instance
     */
    Object.defineProperty(ReviewerClientCount.prototype, "_rejected", {
        get: $util.oneOfGetter($oneOfFields = ["rejected"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new ReviewerClientCount instance using the specified properties.
     * @function create
     * @memberof ReviewerClientCount
     * @static
     * @param {IReviewerClientCount=} [properties] Properties to set
     * @returns {ReviewerClientCount} ReviewerClientCount instance
     */
    ReviewerClientCount.create = function create(properties) {
        return new ReviewerClientCount(properties);
    };

    /**
     * Encodes the specified ReviewerClientCount message. Does not implicitly {@link ReviewerClientCount.verify|verify} messages.
     * @function encode
     * @memberof ReviewerClientCount
     * @static
     * @param {IReviewerClientCount} message ReviewerClientCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerClientCount.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.any != null && Object.hasOwnProperty.call(message, "any"))
        {writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.any);}
        if (message.selected != null && Object.hasOwnProperty.call(message, "selected"))
        {writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.selected);}
        if (message.alternate != null && Object.hasOwnProperty.call(message, "alternate"))
        {writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.alternate);}
        if (message.rejected != null && Object.hasOwnProperty.call(message, "rejected"))
        {writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.rejected);}
        return writer;
    };

    /**
     * Encodes the specified ReviewerClientCount message, length delimited. Does not implicitly {@link ReviewerClientCount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReviewerClientCount
     * @static
     * @param {IReviewerClientCount} message ReviewerClientCount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReviewerClientCount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReviewerClientCount message from the specified reader or buffer.
     * @function decode
     * @memberof ReviewerClientCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReviewerClientCount} ReviewerClientCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerClientCount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReviewerClientCount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.any = reader.uint32();
                break;
            }
            case 2: {
                message.selected = reader.uint32();
                break;
            }
            case 3: {
                message.alternate = reader.uint32();
                break;
            }
            case 4: {
                message.rejected = reader.uint32();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReviewerClientCount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReviewerClientCount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReviewerClientCount} ReviewerClientCount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReviewerClientCount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReviewerClientCount message.
     * @function verify
     * @memberof ReviewerClientCount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReviewerClientCount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.any != null && message.hasOwnProperty("any")) {
            properties._any = 1;
            if (!$util.isInteger(message.any))
            {return "any: integer expected";}
        }
        if (message.selected != null && message.hasOwnProperty("selected")) {
            properties._selected = 1;
            if (!$util.isInteger(message.selected))
            {return "selected: integer expected";}
        }
        if (message.alternate != null && message.hasOwnProperty("alternate")) {
            properties._alternate = 1;
            if (!$util.isInteger(message.alternate))
            {return "alternate: integer expected";}
        }
        if (message.rejected != null && message.hasOwnProperty("rejected")) {
            properties._rejected = 1;
            if (!$util.isInteger(message.rejected))
            {return "rejected: integer expected";}
        }
        return null;
    };

    /**
     * Creates a ReviewerClientCount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReviewerClientCount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReviewerClientCount} ReviewerClientCount
     */
    ReviewerClientCount.fromObject = function fromObject(object) {
        if (object instanceof $root.ReviewerClientCount)
        {return object;}
        let message = new $root.ReviewerClientCount();
        if (object.any != null)
        {message.any = object.any >>> 0;}
        if (object.selected != null)
        {message.selected = object.selected >>> 0;}
        if (object.alternate != null)
        {message.alternate = object.alternate >>> 0;}
        if (object.rejected != null)
        {message.rejected = object.rejected >>> 0;}
        return message;
    };

    /**
     * Creates a plain object from a ReviewerClientCount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReviewerClientCount
     * @static
     * @param {ReviewerClientCount} message ReviewerClientCount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReviewerClientCount.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.any != null && message.hasOwnProperty("any")) {
            object.any = message.any;
            if (options.oneofs)
            {object._any = "any";}
        }
        if (message.selected != null && message.hasOwnProperty("selected")) {
            object.selected = message.selected;
            if (options.oneofs)
            {object._selected = "selected";}
        }
        if (message.alternate != null && message.hasOwnProperty("alternate")) {
            object.alternate = message.alternate;
            if (options.oneofs)
            {object._alternate = "alternate";}
        }
        if (message.rejected != null && message.hasOwnProperty("rejected")) {
            object.rejected = message.rejected;
            if (options.oneofs)
            {object._rejected = "rejected";}
        }
        return object;
    };

    /**
     * Converts this ReviewerClientCount to JSON.
     * @function toJSON
     * @memberof ReviewerClientCount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReviewerClientCount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ReviewerClientCount
     * @function getTypeUrl
     * @memberof ReviewerClientCount
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ReviewerClientCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ReviewerClientCount";
    };

    return ReviewerClientCount;
})();

export const Tenant = $root.Tenant = (() => {

    /**
     * Properties of a Tenant.
     * @exports ITenant
     * @interface ITenant
     * @property {string|null} [id] Tenant id
     * @property {string|null} [name] Tenant name
     * @property {string|null} [domainName] Tenant domainName
     * @property {ICDNFile|null} [logo] Tenant logo
     */

    /**
     * Constructs a new Tenant.
     * @exports Tenant
     * @classdesc Represents a Tenant.
     * @implements ITenant
     * @constructor
     * @param {ITenant=} [properties] Properties to set
     */
    function Tenant(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * Tenant id.
     * @member {string|null|undefined} id
     * @memberof Tenant
     * @instance
     */
    Tenant.prototype.id = null;

    /**
     * Tenant name.
     * @member {string|null|undefined} name
     * @memberof Tenant
     * @instance
     */
    Tenant.prototype.name = null;

    /**
     * Tenant domainName.
     * @member {string|null|undefined} domainName
     * @memberof Tenant
     * @instance
     */
    Tenant.prototype.domainName = null;

    /**
     * Tenant logo.
     * @member {ICDNFile|null|undefined} logo
     * @memberof Tenant
     * @instance
     */
    Tenant.prototype.logo = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Tenant _id.
     * @member {"id"|undefined} _id
     * @memberof Tenant
     * @instance
     */
    Object.defineProperty(Tenant.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Tenant _name.
     * @member {"name"|undefined} _name
     * @memberof Tenant
     * @instance
     */
    Object.defineProperty(Tenant.prototype, "_name", {
        get: $util.oneOfGetter($oneOfFields = ["name"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Tenant _domainName.
     * @member {"domainName"|undefined} _domainName
     * @memberof Tenant
     * @instance
     */
    Object.defineProperty(Tenant.prototype, "_domainName", {
        get: $util.oneOfGetter($oneOfFields = ["domainName"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Tenant _logo.
     * @member {"logo"|undefined} _logo
     * @memberof Tenant
     * @instance
     */
    Object.defineProperty(Tenant.prototype, "_logo", {
        get: $util.oneOfGetter($oneOfFields = ["logo"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Tenant instance using the specified properties.
     * @function create
     * @memberof Tenant
     * @static
     * @param {ITenant=} [properties] Properties to set
     * @returns {Tenant} Tenant instance
     */
    Tenant.create = function create(properties) {
        return new Tenant(properties);
    };

    /**
     * Encodes the specified Tenant message. Does not implicitly {@link Tenant.verify|verify} messages.
     * @function encode
     * @memberof Tenant
     * @static
     * @param {ITenant} message Tenant message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tenant.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);}
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);}
        if (message.domainName != null && Object.hasOwnProperty.call(message, "domainName"))
        {writer.uint32(/* id 3, wireType 2 =*/26).string(message.domainName);}
        if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
        {$root.CDNFile.encode(message.logo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();}
        return writer;
    };

    /**
     * Encodes the specified Tenant message, length delimited. Does not implicitly {@link Tenant.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Tenant
     * @static
     * @param {ITenant} message Tenant message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tenant.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Tenant message from the specified reader or buffer.
     * @function decode
     * @memberof Tenant
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Tenant} Tenant
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tenant.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Tenant();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.id = reader.string();
                break;
            }
            case 2: {
                message.name = reader.string();
                break;
            }
            case 3: {
                message.domainName = reader.string();
                break;
            }
            case 4: {
                message.logo = $root.CDNFile.decode(reader, reader.uint32());
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Tenant message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Tenant
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Tenant} Tenant
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tenant.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Tenant message.
     * @function verify
     * @memberof Tenant
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Tenant.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isString(message.id))
            {return "id: string expected";}
        }
        if (message.name != null && message.hasOwnProperty("name")) {
            properties._name = 1;
            if (!$util.isString(message.name))
            {return "name: string expected";}
        }
        if (message.domainName != null && message.hasOwnProperty("domainName")) {
            properties._domainName = 1;
            if (!$util.isString(message.domainName))
            {return "domainName: string expected";}
        }
        if (message.logo != null && message.hasOwnProperty("logo")) {
            properties._logo = 1;
            {
                let error = $root.CDNFile.verify(message.logo);
                if (error)
                {return "logo." + error;}
            }
        }
        return null;
    };

    /**
     * Creates a Tenant message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Tenant
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Tenant} Tenant
     */
    Tenant.fromObject = function fromObject(object) {
        if (object instanceof $root.Tenant)
        {return object;}
        let message = new $root.Tenant();
        if (object.id != null)
        {message.id = String(object.id);}
        if (object.name != null)
        {message.name = String(object.name);}
        if (object.domainName != null)
        {message.domainName = String(object.domainName);}
        if (object.logo != null) {
            if (typeof object.logo !== "object")
            {throw TypeError(".Tenant.logo: object expected");}
            message.logo = $root.CDNFile.fromObject(object.logo);
        }
        return message;
    };

    /**
     * Creates a plain object from a Tenant message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Tenant
     * @static
     * @param {Tenant} message Tenant
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Tenant.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
            {object._id = "id";}
        }
        if (message.name != null && message.hasOwnProperty("name")) {
            object.name = message.name;
            if (options.oneofs)
            {object._name = "name";}
        }
        if (message.domainName != null && message.hasOwnProperty("domainName")) {
            object.domainName = message.domainName;
            if (options.oneofs)
            {object._domainName = "domainName";}
        }
        if (message.logo != null && message.hasOwnProperty("logo")) {
            object.logo = $root.CDNFile.toObject(message.logo, options);
            if (options.oneofs)
            {object._logo = "logo";}
        }
        return object;
    };

    /**
     * Converts this Tenant to JSON.
     * @function toJSON
     * @memberof Tenant
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Tenant.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Tenant
     * @function getTypeUrl
     * @memberof Tenant
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Tenant.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Tenant";
    };

    return Tenant;
})();

export const Campaign = $root.Campaign = (() => {

    /**
     * Properties of a Campaign.
     * @exports ICampaign
     * @interface ICampaign
     * @property {string|null} [id] Campaign id
     * @property {string|null} [name] Campaign name
     * @property {ITenant|null} [tenant] Campaign tenant
     * @property {ITenant|null} [mainTenant] Campaign mainTenant
     * @property {ICampaignSettings|null} [settings] Campaign settings
     */

    /**
     * Constructs a new Campaign.
     * @exports Campaign
     * @classdesc Represents a Campaign.
     * @implements ICampaign
     * @constructor
     * @param {ICampaign=} [properties] Properties to set
     */
    function Campaign(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * Campaign id.
     * @member {string|null|undefined} id
     * @memberof Campaign
     * @instance
     */
    Campaign.prototype.id = null;

    /**
     * Campaign name.
     * @member {string|null|undefined} name
     * @memberof Campaign
     * @instance
     */
    Campaign.prototype.name = null;

    /**
     * Campaign tenant.
     * @member {ITenant|null|undefined} tenant
     * @memberof Campaign
     * @instance
     */
    Campaign.prototype.tenant = null;

    /**
     * Campaign mainTenant.
     * @member {ITenant|null|undefined} mainTenant
     * @memberof Campaign
     * @instance
     */
    Campaign.prototype.mainTenant = null;

    /**
     * Campaign settings.
     * @member {ICampaignSettings|null|undefined} settings
     * @memberof Campaign
     * @instance
     */
    Campaign.prototype.settings = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Campaign _id.
     * @member {"id"|undefined} _id
     * @memberof Campaign
     * @instance
     */
    Object.defineProperty(Campaign.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Campaign _name.
     * @member {"name"|undefined} _name
     * @memberof Campaign
     * @instance
     */
    Object.defineProperty(Campaign.prototype, "_name", {
        get: $util.oneOfGetter($oneOfFields = ["name"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Campaign _tenant.
     * @member {"tenant"|undefined} _tenant
     * @memberof Campaign
     * @instance
     */
    Object.defineProperty(Campaign.prototype, "_tenant", {
        get: $util.oneOfGetter($oneOfFields = ["tenant"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Campaign _mainTenant.
     * @member {"mainTenant"|undefined} _mainTenant
     * @memberof Campaign
     * @instance
     */
    Object.defineProperty(Campaign.prototype, "_mainTenant", {
        get: $util.oneOfGetter($oneOfFields = ["mainTenant"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Campaign _settings.
     * @member {"settings"|undefined} _settings
     * @memberof Campaign
     * @instance
     */
    Object.defineProperty(Campaign.prototype, "_settings", {
        get: $util.oneOfGetter($oneOfFields = ["settings"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Campaign instance using the specified properties.
     * @function create
     * @memberof Campaign
     * @static
     * @param {ICampaign=} [properties] Properties to set
     * @returns {Campaign} Campaign instance
     */
    Campaign.create = function create(properties) {
        return new Campaign(properties);
    };

    /**
     * Encodes the specified Campaign message. Does not implicitly {@link Campaign.verify|verify} messages.
     * @function encode
     * @memberof Campaign
     * @static
     * @param {ICampaign} message Campaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Campaign.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);}
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);}
        if (message.tenant != null && Object.hasOwnProperty.call(message, "tenant"))
        {$root.Tenant.encode(message.tenant, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();}
        if (message.mainTenant != null && Object.hasOwnProperty.call(message, "mainTenant"))
        {$root.Tenant.encode(message.mainTenant, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();}
        if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
        {$root.CampaignSettings.encode(message.settings, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();}
        return writer;
    };

    /**
     * Encodes the specified Campaign message, length delimited. Does not implicitly {@link Campaign.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Campaign
     * @static
     * @param {ICampaign} message Campaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Campaign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Campaign message from the specified reader or buffer.
     * @function decode
     * @memberof Campaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Campaign} Campaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Campaign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Campaign();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.id = reader.string();
                break;
            }
            case 2: {
                message.name = reader.string();
                break;
            }
            case 3: {
                message.tenant = $root.Tenant.decode(reader, reader.uint32());
                break;
            }
            case 4: {
                message.mainTenant = $root.Tenant.decode(reader, reader.uint32());
                break;
            }
            case 5: {
                message.settings = $root.CampaignSettings.decode(reader, reader.uint32());
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Campaign message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Campaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Campaign} Campaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Campaign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Campaign message.
     * @function verify
     * @memberof Campaign
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Campaign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            properties._id = 1;
            if (!$util.isString(message.id))
            {return "id: string expected";}
        }
        if (message.name != null && message.hasOwnProperty("name")) {
            properties._name = 1;
            if (!$util.isString(message.name))
            {return "name: string expected";}
        }
        if (message.tenant != null && message.hasOwnProperty("tenant")) {
            properties._tenant = 1;
            {
                let error = $root.Tenant.verify(message.tenant);
                if (error)
                {return "tenant." + error;}
            }
        }
        if (message.mainTenant != null && message.hasOwnProperty("mainTenant")) {
            properties._mainTenant = 1;
            {
                let error = $root.Tenant.verify(message.mainTenant);
                if (error)
                {return "mainTenant." + error;}
            }
        }
        if (message.settings != null && message.hasOwnProperty("settings")) {
            properties._settings = 1;
            {
                let error = $root.CampaignSettings.verify(message.settings);
                if (error)
                {return "settings." + error;}
            }
        }
        return null;
    };

    /**
     * Creates a Campaign message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Campaign
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Campaign} Campaign
     */
    Campaign.fromObject = function fromObject(object) {
        if (object instanceof $root.Campaign)
        {return object;}
        let message = new $root.Campaign();
        if (object.id != null)
        {message.id = String(object.id);}
        if (object.name != null)
        {message.name = String(object.name);}
        if (object.tenant != null) {
            if (typeof object.tenant !== "object")
            {throw TypeError(".Campaign.tenant: object expected");}
            message.tenant = $root.Tenant.fromObject(object.tenant);
        }
        if (object.mainTenant != null) {
            if (typeof object.mainTenant !== "object")
            {throw TypeError(".Campaign.mainTenant: object expected");}
            message.mainTenant = $root.Tenant.fromObject(object.mainTenant);
        }
        if (object.settings != null) {
            if (typeof object.settings !== "object")
            {throw TypeError(".Campaign.settings: object expected");}
            message.settings = $root.CampaignSettings.fromObject(object.settings);
        }
        return message;
    };

    /**
     * Creates a plain object from a Campaign message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Campaign
     * @static
     * @param {Campaign} message Campaign
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Campaign.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.id != null && message.hasOwnProperty("id")) {
            object.id = message.id;
            if (options.oneofs)
            {object._id = "id";}
        }
        if (message.name != null && message.hasOwnProperty("name")) {
            object.name = message.name;
            if (options.oneofs)
            {object._name = "name";}
        }
        if (message.tenant != null && message.hasOwnProperty("tenant")) {
            object.tenant = $root.Tenant.toObject(message.tenant, options);
            if (options.oneofs)
            {object._tenant = "tenant";}
        }
        if (message.mainTenant != null && message.hasOwnProperty("mainTenant")) {
            object.mainTenant = $root.Tenant.toObject(message.mainTenant, options);
            if (options.oneofs)
            {object._mainTenant = "mainTenant";}
        }
        if (message.settings != null && message.hasOwnProperty("settings")) {
            object.settings = $root.CampaignSettings.toObject(message.settings, options);
            if (options.oneofs)
            {object._settings = "settings";}
        }
        return object;
    };

    /**
     * Converts this Campaign to JSON.
     * @function toJSON
     * @memberof Campaign
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Campaign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Campaign
     * @function getTypeUrl
     * @memberof Campaign
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Campaign.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Campaign";
    };

    return Campaign;
})();

export const CampaignSettings = $root.CampaignSettings = (() => {

    /**
     * Properties of a CampaignSettings.
     * @exports ICampaignSettings
     * @interface ICampaignSettings
     * @property {number|Long|null} [closeAt] CampaignSettings closeAt
     * @property {number|Long|null} [openAt] CampaignSettings openAt
     */

    /**
     * Constructs a new CampaignSettings.
     * @exports CampaignSettings
     * @classdesc Represents a CampaignSettings.
     * @implements ICampaignSettings
     * @constructor
     * @param {ICampaignSettings=} [properties] Properties to set
     */
    function CampaignSettings(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * CampaignSettings closeAt.
     * @member {number|Long|null|undefined} closeAt
     * @memberof CampaignSettings
     * @instance
     */
    CampaignSettings.prototype.closeAt = null;

    /**
     * CampaignSettings openAt.
     * @member {number|Long|null|undefined} openAt
     * @memberof CampaignSettings
     * @instance
     */
    CampaignSettings.prototype.openAt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * CampaignSettings _closeAt.
     * @member {"closeAt"|undefined} _closeAt
     * @memberof CampaignSettings
     * @instance
     */
    Object.defineProperty(CampaignSettings.prototype, "_closeAt", {
        get: $util.oneOfGetter($oneOfFields = ["closeAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignSettings _openAt.
     * @member {"openAt"|undefined} _openAt
     * @memberof CampaignSettings
     * @instance
     */
    Object.defineProperty(CampaignSettings.prototype, "_openAt", {
        get: $util.oneOfGetter($oneOfFields = ["openAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new CampaignSettings instance using the specified properties.
     * @function create
     * @memberof CampaignSettings
     * @static
     * @param {ICampaignSettings=} [properties] Properties to set
     * @returns {CampaignSettings} CampaignSettings instance
     */
    CampaignSettings.create = function create(properties) {
        return new CampaignSettings(properties);
    };

    /**
     * Encodes the specified CampaignSettings message. Does not implicitly {@link CampaignSettings.verify|verify} messages.
     * @function encode
     * @memberof CampaignSettings
     * @static
     * @param {ICampaignSettings} message CampaignSettings message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignSettings.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.closeAt != null && Object.hasOwnProperty.call(message, "closeAt"))
        {writer.uint32(/* id 1, wireType 0 =*/8).int64(message.closeAt);}
        if (message.openAt != null && Object.hasOwnProperty.call(message, "openAt"))
        {writer.uint32(/* id 2, wireType 0 =*/16).int64(message.openAt);}
        return writer;
    };

    /**
     * Encodes the specified CampaignSettings message, length delimited. Does not implicitly {@link CampaignSettings.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CampaignSettings
     * @static
     * @param {ICampaignSettings} message CampaignSettings message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignSettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CampaignSettings message from the specified reader or buffer.
     * @function decode
     * @memberof CampaignSettings
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CampaignSettings} CampaignSettings
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignSettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CampaignSettings();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.closeAt = reader.int64();
                break;
            }
            case 2: {
                message.openAt = reader.int64();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CampaignSettings message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CampaignSettings
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CampaignSettings} CampaignSettings
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignSettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CampaignSettings message.
     * @function verify
     * @memberof CampaignSettings
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CampaignSettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.closeAt != null && message.hasOwnProperty("closeAt")) {
            properties._closeAt = 1;
            if (!$util.isInteger(message.closeAt) && !(message.closeAt && $util.isInteger(message.closeAt.low) && $util.isInteger(message.closeAt.high)))
            {return "closeAt: integer|Long expected";}
        }
        if (message.openAt != null && message.hasOwnProperty("openAt")) {
            properties._openAt = 1;
            if (!$util.isInteger(message.openAt) && !(message.openAt && $util.isInteger(message.openAt.low) && $util.isInteger(message.openAt.high)))
            {return "openAt: integer|Long expected";}
        }
        return null;
    };

    /**
     * Creates a CampaignSettings message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CampaignSettings
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CampaignSettings} CampaignSettings
     */
    CampaignSettings.fromObject = function fromObject(object) {
        if (object instanceof $root.CampaignSettings)
        {return object;}
        let message = new $root.CampaignSettings();
        if (object.closeAt != null)
        {if ($util.Long)
        {(message.closeAt = $util.Long.fromValue(object.closeAt)).unsigned = false;}
        else if (typeof object.closeAt === "string")
        {message.closeAt = parseInt(object.closeAt, 10);}
        else if (typeof object.closeAt === "number")
        {message.closeAt = object.closeAt;}
        else if (typeof object.closeAt === "object")
        {message.closeAt = new $util.LongBits(object.closeAt.low >>> 0, object.closeAt.high >>> 0).toNumber();}}
        if (object.openAt != null)
        {if ($util.Long)
        {(message.openAt = $util.Long.fromValue(object.openAt)).unsigned = false;}
        else if (typeof object.openAt === "string")
        {message.openAt = parseInt(object.openAt, 10);}
        else if (typeof object.openAt === "number")
        {message.openAt = object.openAt;}
        else if (typeof object.openAt === "object")
        {message.openAt = new $util.LongBits(object.openAt.low >>> 0, object.openAt.high >>> 0).toNumber();}}
        return message;
    };

    /**
     * Creates a plain object from a CampaignSettings message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CampaignSettings
     * @static
     * @param {CampaignSettings} message CampaignSettings
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CampaignSettings.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (message.closeAt != null && message.hasOwnProperty("closeAt")) {
            if (typeof message.closeAt === "number")
            {object.closeAt = options.longs === String ? String(message.closeAt) : message.closeAt;}
            else
            {object.closeAt = options.longs === String ? $util.Long.prototype.toString.call(message.closeAt) : options.longs === Number ? new $util.LongBits(message.closeAt.low >>> 0, message.closeAt.high >>> 0).toNumber() : message.closeAt;}
            if (options.oneofs)
            {object._closeAt = "closeAt";}
        }
        if (message.openAt != null && message.hasOwnProperty("openAt")) {
            if (typeof message.openAt === "number")
            {object.openAt = options.longs === String ? String(message.openAt) : message.openAt;}
            else
            {object.openAt = options.longs === String ? $util.Long.prototype.toString.call(message.openAt) : options.longs === Number ? new $util.LongBits(message.openAt.low >>> 0, message.openAt.high >>> 0).toNumber() : message.openAt;}
            if (options.oneofs)
            {object._openAt = "openAt";}
        }
        return object;
    };

    /**
     * Converts this CampaignSettings to JSON.
     * @function toJSON
     * @memberof CampaignSettings
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CampaignSettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CampaignSettings
     * @function getTypeUrl
     * @memberof CampaignSettings
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CampaignSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CampaignSettings";
    };

    return CampaignSettings;
})();

export const CampaignApplication = $root.CampaignApplication = (() => {

    /**
     * Properties of a CampaignApplication.
     * @exports ICampaignApplication
     * @interface ICampaignApplication
     * @property {string|null} [id] CampaignApplication id
     * @property {CampaignApplicationState|null} [state] CampaignApplication state
     * @property {number|Long|null} [appliedAt] CampaignApplication appliedAt
     * @property {IReviewer|null} [reviewer] CampaignApplication reviewer
     * @property {boolean|null} [isUnselected] CampaignApplication isUnselected
     * @property {string|null} [discountCode] CampaignApplication discountCode
     * @property {IAddress|null} [deliveryAddress] CampaignApplication deliveryAddress
     * @property {ICampaignApplicationResolution|null} [latestResolution] CampaignApplication latestResolution
     * @property {ICampaignApplicationResolution|null} [pendingResolution] CampaignApplication pendingResolution
     * @property {boolean|null} [isDelivered] CampaignApplication isDelivered
     * @property {number|Long|null} [deliveryConfirmedAt] CampaignApplication deliveryConfirmedAt
     * @property {Array.<number|Long>|null} [dueReviewNotificationsAt] CampaignApplication dueReviewNotificationsAt
     * @property {number|Long|null} [deadlineAt] CampaignApplication deadlineAt
     * @property {number|null} [submittedReviewsCount] CampaignApplication submittedReviewsCount
     * @property {Array.<ICampaignApplicationResolution>|null} [resolutions] CampaignApplication resolutions
     * @property {Array.<IKVPair>|null} [questionnaireResponseAnswers] CampaignApplication questionnaireResponseAnswers
     * @property {boolean|null} [isOrdered] CampaignApplication isOrdered
     * @property {number|Long|null} [orderConfirmedAt] CampaignApplication orderConfirmedAt
     */

    /**
     * Constructs a new CampaignApplication.
     * @exports CampaignApplication
     * @classdesc Represents a CampaignApplication.
     * @implements ICampaignApplication
     * @constructor
     * @param {ICampaignApplication=} [properties] Properties to set
     */
    function CampaignApplication(properties) {
        this.dueReviewNotificationsAt = [];
        this.resolutions = [];
        this.questionnaireResponseAnswers = [];
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * CampaignApplication id.
     * @member {string} id
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.id = "";

    /**
     * CampaignApplication state.
     * @member {CampaignApplicationState} state
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.state = 1;

    /**
     * CampaignApplication appliedAt.
     * @member {number|Long} appliedAt
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.appliedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * CampaignApplication reviewer.
     * @member {IReviewer|null|undefined} reviewer
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.reviewer = null;

    /**
     * CampaignApplication isUnselected.
     * @member {boolean|null|undefined} isUnselected
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.isUnselected = null;

    /**
     * CampaignApplication discountCode.
     * @member {string|null|undefined} discountCode
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.discountCode = null;

    /**
     * CampaignApplication deliveryAddress.
     * @member {IAddress|null|undefined} deliveryAddress
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.deliveryAddress = null;

    /**
     * CampaignApplication latestResolution.
     * @member {ICampaignApplicationResolution|null|undefined} latestResolution
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.latestResolution = null;

    /**
     * CampaignApplication pendingResolution.
     * @member {ICampaignApplicationResolution|null|undefined} pendingResolution
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.pendingResolution = null;

    /**
     * CampaignApplication isDelivered.
     * @member {boolean|null|undefined} isDelivered
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.isDelivered = null;

    /**
     * CampaignApplication deliveryConfirmedAt.
     * @member {number|Long|null|undefined} deliveryConfirmedAt
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.deliveryConfirmedAt = null;

    /**
     * CampaignApplication dueReviewNotificationsAt.
     * @member {Array.<number|Long>} dueReviewNotificationsAt
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.dueReviewNotificationsAt = $util.emptyArray;

    /**
     * CampaignApplication deadlineAt.
     * @member {number|Long|null|undefined} deadlineAt
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.deadlineAt = null;

    /**
     * CampaignApplication submittedReviewsCount.
     * @member {number|null|undefined} submittedReviewsCount
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.submittedReviewsCount = null;

    /**
     * CampaignApplication resolutions.
     * @member {Array.<ICampaignApplicationResolution>} resolutions
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.resolutions = $util.emptyArray;

    /**
     * CampaignApplication questionnaireResponseAnswers.
     * @member {Array.<IKVPair>} questionnaireResponseAnswers
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.questionnaireResponseAnswers = $util.emptyArray;

    /**
     * CampaignApplication isOrdered.
     * @member {boolean|null|undefined} isOrdered
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.isOrdered = null;

    /**
     * CampaignApplication orderConfirmedAt.
     * @member {number|Long|null|undefined} orderConfirmedAt
     * @memberof CampaignApplication
     * @instance
     */
    CampaignApplication.prototype.orderConfirmedAt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * CampaignApplication _isUnselected.
     * @member {"isUnselected"|undefined} _isUnselected
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_isUnselected", {
        get: $util.oneOfGetter($oneOfFields = ["isUnselected"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _discountCode.
     * @member {"discountCode"|undefined} _discountCode
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_discountCode", {
        get: $util.oneOfGetter($oneOfFields = ["discountCode"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _latestResolution.
     * @member {"latestResolution"|undefined} _latestResolution
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_latestResolution", {
        get: $util.oneOfGetter($oneOfFields = ["latestResolution"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _pendingResolution.
     * @member {"pendingResolution"|undefined} _pendingResolution
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_pendingResolution", {
        get: $util.oneOfGetter($oneOfFields = ["pendingResolution"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _isDelivered.
     * @member {"isDelivered"|undefined} _isDelivered
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_isDelivered", {
        get: $util.oneOfGetter($oneOfFields = ["isDelivered"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _deliveryConfirmedAt.
     * @member {"deliveryConfirmedAt"|undefined} _deliveryConfirmedAt
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_deliveryConfirmedAt", {
        get: $util.oneOfGetter($oneOfFields = ["deliveryConfirmedAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _deadlineAt.
     * @member {"deadlineAt"|undefined} _deadlineAt
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_deadlineAt", {
        get: $util.oneOfGetter($oneOfFields = ["deadlineAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _submittedReviewsCount.
     * @member {"submittedReviewsCount"|undefined} _submittedReviewsCount
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_submittedReviewsCount", {
        get: $util.oneOfGetter($oneOfFields = ["submittedReviewsCount"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _isOrdered.
     * @member {"isOrdered"|undefined} _isOrdered
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_isOrdered", {
        get: $util.oneOfGetter($oneOfFields = ["isOrdered"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * CampaignApplication _orderConfirmedAt.
     * @member {"orderConfirmedAt"|undefined} _orderConfirmedAt
     * @memberof CampaignApplication
     * @instance
     */
    Object.defineProperty(CampaignApplication.prototype, "_orderConfirmedAt", {
        get: $util.oneOfGetter($oneOfFields = ["orderConfirmedAt"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new CampaignApplication instance using the specified properties.
     * @function create
     * @memberof CampaignApplication
     * @static
     * @param {ICampaignApplication=} [properties] Properties to set
     * @returns {CampaignApplication} CampaignApplication instance
     */
    CampaignApplication.create = function create(properties) {
        return new CampaignApplication(properties);
    };

    /**
     * Encodes the specified CampaignApplication message. Does not implicitly {@link CampaignApplication.verify|verify} messages.
     * @function encode
     * @memberof CampaignApplication
     * @static
     * @param {ICampaignApplication} message CampaignApplication message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignApplication.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
        {writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);}
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
        {writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);}
        if (message.appliedAt != null && Object.hasOwnProperty.call(message, "appliedAt"))
        {writer.uint32(/* id 3, wireType 0 =*/24).int64(message.appliedAt);}
        if (message.reviewer != null && Object.hasOwnProperty.call(message, "reviewer"))
        {$root.Reviewer.encode(message.reviewer, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();}
        if (message.isUnselected != null && Object.hasOwnProperty.call(message, "isUnselected"))
        {writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isUnselected);}
        if (message.discountCode != null && Object.hasOwnProperty.call(message, "discountCode"))
        {writer.uint32(/* id 6, wireType 2 =*/50).string(message.discountCode);}
        if (message.deliveryAddress != null && Object.hasOwnProperty.call(message, "deliveryAddress"))
        {$root.Address.encode(message.deliveryAddress, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();}
        if (message.latestResolution != null && Object.hasOwnProperty.call(message, "latestResolution"))
        {$root.CampaignApplicationResolution.encode(message.latestResolution, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();}
        if (message.pendingResolution != null && Object.hasOwnProperty.call(message, "pendingResolution"))
        {$root.CampaignApplicationResolution.encode(message.pendingResolution, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();}
        if (message.isDelivered != null && Object.hasOwnProperty.call(message, "isDelivered"))
        {writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isDelivered);}
        if (message.deliveryConfirmedAt != null && Object.hasOwnProperty.call(message, "deliveryConfirmedAt"))
        {writer.uint32(/* id 11, wireType 0 =*/88).int64(message.deliveryConfirmedAt);}
        if (message.dueReviewNotificationsAt != null && message.dueReviewNotificationsAt.length) {
            writer.uint32(/* id 12, wireType 2 =*/98).fork();
            for (let i = 0; i < message.dueReviewNotificationsAt.length; ++i)
            {writer.int64(message.dueReviewNotificationsAt[i]);}
            writer.ldelim();
        }
        if (message.deadlineAt != null && Object.hasOwnProperty.call(message, "deadlineAt"))
        {writer.uint32(/* id 13, wireType 0 =*/104).int64(message.deadlineAt);}
        if (message.submittedReviewsCount != null && Object.hasOwnProperty.call(message, "submittedReviewsCount"))
        {writer.uint32(/* id 14, wireType 0 =*/112).int32(message.submittedReviewsCount);}
        if (message.resolutions != null && message.resolutions.length)
        {for (let i = 0; i < message.resolutions.length; ++i)
        {$root.CampaignApplicationResolution.encode(message.resolutions[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();}}
        if (message.questionnaireResponseAnswers != null && message.questionnaireResponseAnswers.length)
        {for (let i = 0; i < message.questionnaireResponseAnswers.length; ++i)
        {$root.KVPair.encode(message.questionnaireResponseAnswers[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();}}
        if (message.isOrdered != null && Object.hasOwnProperty.call(message, "isOrdered"))
        {writer.uint32(/* id 17, wireType 0 =*/136).bool(message.isOrdered);}
        if (message.orderConfirmedAt != null && Object.hasOwnProperty.call(message, "orderConfirmedAt"))
        {writer.uint32(/* id 18, wireType 0 =*/144).int64(message.orderConfirmedAt);}
        return writer;
    };

    /**
     * Encodes the specified CampaignApplication message, length delimited. Does not implicitly {@link CampaignApplication.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CampaignApplication
     * @static
     * @param {ICampaignApplication} message CampaignApplication message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignApplication.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CampaignApplication message from the specified reader or buffer.
     * @function decode
     * @memberof CampaignApplication
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CampaignApplication} CampaignApplication
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignApplication.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CampaignApplication();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.id = reader.string();
                break;
            }
            case 2: {
                message.state = reader.int32();
                break;
            }
            case 3: {
                message.appliedAt = reader.int64();
                break;
            }
            case 4: {
                message.reviewer = $root.Reviewer.decode(reader, reader.uint32());
                break;
            }
            case 5: {
                message.isUnselected = reader.bool();
                break;
            }
            case 6: {
                message.discountCode = reader.string();
                break;
            }
            case 7: {
                message.deliveryAddress = $root.Address.decode(reader, reader.uint32());
                break;
            }
            case 8: {
                message.latestResolution = $root.CampaignApplicationResolution.decode(reader, reader.uint32());
                break;
            }
            case 9: {
                message.pendingResolution = $root.CampaignApplicationResolution.decode(reader, reader.uint32());
                break;
            }
            case 10: {
                message.isDelivered = reader.bool();
                break;
            }
            case 11: {
                message.deliveryConfirmedAt = reader.int64();
                break;
            }
            case 12: {
                if (!(message.dueReviewNotificationsAt && message.dueReviewNotificationsAt.length))
                {message.dueReviewNotificationsAt = [];}
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                    {message.dueReviewNotificationsAt.push(reader.int64());}
                } else
                {message.dueReviewNotificationsAt.push(reader.int64());}
                break;
            }
            case 13: {
                message.deadlineAt = reader.int64();
                break;
            }
            case 14: {
                message.submittedReviewsCount = reader.int32();
                break;
            }
            case 15: {
                if (!(message.resolutions && message.resolutions.length))
                {message.resolutions = [];}
                message.resolutions.push($root.CampaignApplicationResolution.decode(reader, reader.uint32()));
                break;
            }
            case 16: {
                if (!(message.questionnaireResponseAnswers && message.questionnaireResponseAnswers.length))
                {message.questionnaireResponseAnswers = [];}
                message.questionnaireResponseAnswers.push($root.KVPair.decode(reader, reader.uint32()));
                break;
            }
            case 17: {
                message.isOrdered = reader.bool();
                break;
            }
            case 18: {
                message.orderConfirmedAt = reader.int64();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CampaignApplication message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CampaignApplication
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CampaignApplication} CampaignApplication
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignApplication.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CampaignApplication message.
     * @function verify
     * @memberof CampaignApplication
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CampaignApplication.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id"))
        {if (!$util.isString(message.id))
        {return "id: string expected";}}
        if (message.state != null && message.hasOwnProperty("state"))
        {switch (message.state) {
        default:
            return "state: enum value expected";
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }}
        if (message.appliedAt != null && message.hasOwnProperty("appliedAt"))
        {if (!$util.isInteger(message.appliedAt) && !(message.appliedAt && $util.isInteger(message.appliedAt.low) && $util.isInteger(message.appliedAt.high)))
        {return "appliedAt: integer|Long expected";}}
        if (message.reviewer != null && message.hasOwnProperty("reviewer")) {
            let error = $root.Reviewer.verify(message.reviewer);
            if (error)
            {return "reviewer." + error;}
        }
        if (message.isUnselected != null && message.hasOwnProperty("isUnselected")) {
            properties._isUnselected = 1;
            if (typeof message.isUnselected !== "boolean")
            {return "isUnselected: boolean expected";}
        }
        if (message.discountCode != null && message.hasOwnProperty("discountCode")) {
            properties._discountCode = 1;
            if (!$util.isString(message.discountCode))
            {return "discountCode: string expected";}
        }
        if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress")) {
            let error = $root.Address.verify(message.deliveryAddress);
            if (error)
            {return "deliveryAddress." + error;}
        }
        if (message.latestResolution != null && message.hasOwnProperty("latestResolution")) {
            properties._latestResolution = 1;
            {
                let error = $root.CampaignApplicationResolution.verify(message.latestResolution);
                if (error)
                {return "latestResolution." + error;}
            }
        }
        if (message.pendingResolution != null && message.hasOwnProperty("pendingResolution")) {
            properties._pendingResolution = 1;
            {
                let error = $root.CampaignApplicationResolution.verify(message.pendingResolution);
                if (error)
                {return "pendingResolution." + error;}
            }
        }
        if (message.isDelivered != null && message.hasOwnProperty("isDelivered")) {
            properties._isDelivered = 1;
            if (typeof message.isDelivered !== "boolean")
            {return "isDelivered: boolean expected";}
        }
        if (message.deliveryConfirmedAt != null && message.hasOwnProperty("deliveryConfirmedAt")) {
            properties._deliveryConfirmedAt = 1;
            if (!$util.isInteger(message.deliveryConfirmedAt) && !(message.deliveryConfirmedAt && $util.isInteger(message.deliveryConfirmedAt.low) && $util.isInteger(message.deliveryConfirmedAt.high)))
            {return "deliveryConfirmedAt: integer|Long expected";}
        }
        if (message.dueReviewNotificationsAt != null && message.hasOwnProperty("dueReviewNotificationsAt")) {
            if (!Array.isArray(message.dueReviewNotificationsAt))
            {return "dueReviewNotificationsAt: array expected";}
            for (let i = 0; i < message.dueReviewNotificationsAt.length; ++i)
            {if (!$util.isInteger(message.dueReviewNotificationsAt[i]) && !(message.dueReviewNotificationsAt[i] && $util.isInteger(message.dueReviewNotificationsAt[i].low) && $util.isInteger(message.dueReviewNotificationsAt[i].high)))
            {return "dueReviewNotificationsAt: integer|Long[] expected";}}
        }
        if (message.deadlineAt != null && message.hasOwnProperty("deadlineAt")) {
            properties._deadlineAt = 1;
            if (!$util.isInteger(message.deadlineAt) && !(message.deadlineAt && $util.isInteger(message.deadlineAt.low) && $util.isInteger(message.deadlineAt.high)))
            {return "deadlineAt: integer|Long expected";}
        }
        if (message.submittedReviewsCount != null && message.hasOwnProperty("submittedReviewsCount")) {
            properties._submittedReviewsCount = 1;
            if (!$util.isInteger(message.submittedReviewsCount))
            {return "submittedReviewsCount: integer expected";}
        }
        if (message.resolutions != null && message.hasOwnProperty("resolutions")) {
            if (!Array.isArray(message.resolutions))
            {return "resolutions: array expected";}
            for (let i = 0; i < message.resolutions.length; ++i) {
                let error = $root.CampaignApplicationResolution.verify(message.resolutions[i]);
                if (error)
                {return "resolutions." + error;}
            }
        }
        if (message.questionnaireResponseAnswers != null && message.hasOwnProperty("questionnaireResponseAnswers")) {
            if (!Array.isArray(message.questionnaireResponseAnswers))
            {return "questionnaireResponseAnswers: array expected";}
            for (let i = 0; i < message.questionnaireResponseAnswers.length; ++i) {
                let error = $root.KVPair.verify(message.questionnaireResponseAnswers[i]);
                if (error)
                {return "questionnaireResponseAnswers." + error;}
            }
        }
        if (message.isOrdered != null && message.hasOwnProperty("isOrdered")) {
            properties._isOrdered = 1;
            if (typeof message.isOrdered !== "boolean")
            {return "isOrdered: boolean expected";}
        }
        if (message.orderConfirmedAt != null && message.hasOwnProperty("orderConfirmedAt")) {
            properties._orderConfirmedAt = 1;
            if (!$util.isInteger(message.orderConfirmedAt) && !(message.orderConfirmedAt && $util.isInteger(message.orderConfirmedAt.low) && $util.isInteger(message.orderConfirmedAt.high)))
            {return "orderConfirmedAt: integer|Long expected";}
        }
        return null;
    };

    /**
     * Creates a CampaignApplication message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CampaignApplication
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CampaignApplication} CampaignApplication
     */
    CampaignApplication.fromObject = function fromObject(object) {
        if (object instanceof $root.CampaignApplication)
        {return object;}
        let message = new $root.CampaignApplication();
        if (object.id != null)
        {message.id = String(object.id);}
        switch (object.state) {
        default:
            if (typeof object.state === "number") {
                message.state = object.state;
                break;
            }
            break;
        case "draft":
        case 1:
            message.state = 1;
            break;
        case "submitted":
        case 2:
            message.state = 2;
            break;
        case "pending":
        case 3:
            message.state = 3;
            break;
        case "resolved":
        case 4:
            message.state = 4;
            break;
        }
        if (object.appliedAt != null)
        {if ($util.Long)
        {(message.appliedAt = $util.Long.fromValue(object.appliedAt)).unsigned = false;}
        else if (typeof object.appliedAt === "string")
        {message.appliedAt = parseInt(object.appliedAt, 10);}
        else if (typeof object.appliedAt === "number")
        {message.appliedAt = object.appliedAt;}
        else if (typeof object.appliedAt === "object")
        {message.appliedAt = new $util.LongBits(object.appliedAt.low >>> 0, object.appliedAt.high >>> 0).toNumber();}}
        if (object.reviewer != null) {
            if (typeof object.reviewer !== "object")
            {throw TypeError(".CampaignApplication.reviewer: object expected");}
            message.reviewer = $root.Reviewer.fromObject(object.reviewer);
        }
        if (object.isUnselected != null)
        {message.isUnselected = Boolean(object.isUnselected);}
        if (object.discountCode != null)
        {message.discountCode = String(object.discountCode);}
        if (object.deliveryAddress != null) {
            if (typeof object.deliveryAddress !== "object")
            {throw TypeError(".CampaignApplication.deliveryAddress: object expected");}
            message.deliveryAddress = $root.Address.fromObject(object.deliveryAddress);
        }
        if (object.latestResolution != null) {
            if (typeof object.latestResolution !== "object")
            {throw TypeError(".CampaignApplication.latestResolution: object expected");}
            message.latestResolution = $root.CampaignApplicationResolution.fromObject(object.latestResolution);
        }
        if (object.pendingResolution != null) {
            if (typeof object.pendingResolution !== "object")
            {throw TypeError(".CampaignApplication.pendingResolution: object expected");}
            message.pendingResolution = $root.CampaignApplicationResolution.fromObject(object.pendingResolution);
        }
        if (object.isDelivered != null)
        {message.isDelivered = Boolean(object.isDelivered);}
        if (object.deliveryConfirmedAt != null)
        {if ($util.Long)
        {(message.deliveryConfirmedAt = $util.Long.fromValue(object.deliveryConfirmedAt)).unsigned = false;}
        else if (typeof object.deliveryConfirmedAt === "string")
        {message.deliveryConfirmedAt = parseInt(object.deliveryConfirmedAt, 10);}
        else if (typeof object.deliveryConfirmedAt === "number")
        {message.deliveryConfirmedAt = object.deliveryConfirmedAt;}
        else if (typeof object.deliveryConfirmedAt === "object")
        {message.deliveryConfirmedAt = new $util.LongBits(object.deliveryConfirmedAt.low >>> 0, object.deliveryConfirmedAt.high >>> 0).toNumber();}}
        if (object.dueReviewNotificationsAt) {
            if (!Array.isArray(object.dueReviewNotificationsAt))
            {throw TypeError(".CampaignApplication.dueReviewNotificationsAt: array expected");}
            message.dueReviewNotificationsAt = [];
            for (let i = 0; i < object.dueReviewNotificationsAt.length; ++i)
            {if ($util.Long)
            {(message.dueReviewNotificationsAt[i] = $util.Long.fromValue(object.dueReviewNotificationsAt[i])).unsigned = false;}
            else if (typeof object.dueReviewNotificationsAt[i] === "string")
            {message.dueReviewNotificationsAt[i] = parseInt(object.dueReviewNotificationsAt[i], 10);}
            else if (typeof object.dueReviewNotificationsAt[i] === "number")
            {message.dueReviewNotificationsAt[i] = object.dueReviewNotificationsAt[i];}
            else if (typeof object.dueReviewNotificationsAt[i] === "object")
            {message.dueReviewNotificationsAt[i] = new $util.LongBits(object.dueReviewNotificationsAt[i].low >>> 0, object.dueReviewNotificationsAt[i].high >>> 0).toNumber();}}
        }
        if (object.deadlineAt != null)
        {if ($util.Long)
        {(message.deadlineAt = $util.Long.fromValue(object.deadlineAt)).unsigned = false;}
        else if (typeof object.deadlineAt === "string")
        {message.deadlineAt = parseInt(object.deadlineAt, 10);}
        else if (typeof object.deadlineAt === "number")
        {message.deadlineAt = object.deadlineAt;}
        else if (typeof object.deadlineAt === "object")
        {message.deadlineAt = new $util.LongBits(object.deadlineAt.low >>> 0, object.deadlineAt.high >>> 0).toNumber();}}
        if (object.submittedReviewsCount != null)
        {message.submittedReviewsCount = object.submittedReviewsCount | 0;}
        if (object.resolutions) {
            if (!Array.isArray(object.resolutions))
            {throw TypeError(".CampaignApplication.resolutions: array expected");}
            message.resolutions = [];
            for (let i = 0; i < object.resolutions.length; ++i) {
                if (typeof object.resolutions[i] !== "object")
                {throw TypeError(".CampaignApplication.resolutions: object expected");}
                message.resolutions[i] = $root.CampaignApplicationResolution.fromObject(object.resolutions[i]);
            }
        }
        if (object.questionnaireResponseAnswers) {
            if (!Array.isArray(object.questionnaireResponseAnswers))
            {throw TypeError(".CampaignApplication.questionnaireResponseAnswers: array expected");}
            message.questionnaireResponseAnswers = [];
            for (let i = 0; i < object.questionnaireResponseAnswers.length; ++i) {
                if (typeof object.questionnaireResponseAnswers[i] !== "object")
                {throw TypeError(".CampaignApplication.questionnaireResponseAnswers: object expected");}
                message.questionnaireResponseAnswers[i] = $root.KVPair.fromObject(object.questionnaireResponseAnswers[i]);
            }
        }
        if (object.isOrdered != null)
        {message.isOrdered = Boolean(object.isOrdered);}
        if (object.orderConfirmedAt != null)
        {if ($util.Long)
        {(message.orderConfirmedAt = $util.Long.fromValue(object.orderConfirmedAt)).unsigned = false;}
        else if (typeof object.orderConfirmedAt === "string")
        {message.orderConfirmedAt = parseInt(object.orderConfirmedAt, 10);}
        else if (typeof object.orderConfirmedAt === "number")
        {message.orderConfirmedAt = object.orderConfirmedAt;}
        else if (typeof object.orderConfirmedAt === "object")
        {message.orderConfirmedAt = new $util.LongBits(object.orderConfirmedAt.low >>> 0, object.orderConfirmedAt.high >>> 0).toNumber();}}
        return message;
    };

    /**
     * Creates a plain object from a CampaignApplication message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CampaignApplication
     * @static
     * @param {CampaignApplication} message CampaignApplication
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CampaignApplication.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.arrays || options.defaults) {
            object.dueReviewNotificationsAt = [];
            object.resolutions = [];
            object.questionnaireResponseAnswers = [];
        }
        if (options.defaults) {
            object.id = "";
            object.state = options.enums === String ? "draft" : 1;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.appliedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
            {object.appliedAt = options.longs === String ? "0" : 0;}
            object.reviewer = null;
            object.deliveryAddress = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
        {object.id = message.id;}
        if (message.state != null && message.hasOwnProperty("state"))
        {object.state = options.enums === String ? $root.CampaignApplicationState[message.state] === undefined ? message.state : $root.CampaignApplicationState[message.state] : message.state;}
        if (message.appliedAt != null && message.hasOwnProperty("appliedAt"))
        {if (typeof message.appliedAt === "number")
        {object.appliedAt = options.longs === String ? String(message.appliedAt) : message.appliedAt;}
        else
        {object.appliedAt = options.longs === String ? $util.Long.prototype.toString.call(message.appliedAt) : options.longs === Number ? new $util.LongBits(message.appliedAt.low >>> 0, message.appliedAt.high >>> 0).toNumber() : message.appliedAt;}}
        if (message.reviewer != null && message.hasOwnProperty("reviewer"))
        {object.reviewer = $root.Reviewer.toObject(message.reviewer, options);}
        if (message.isUnselected != null && message.hasOwnProperty("isUnselected")) {
            object.isUnselected = message.isUnselected;
            if (options.oneofs)
            {object._isUnselected = "isUnselected";}
        }
        if (message.discountCode != null && message.hasOwnProperty("discountCode")) {
            object.discountCode = message.discountCode;
            if (options.oneofs)
            {object._discountCode = "discountCode";}
        }
        if (message.deliveryAddress != null && message.hasOwnProperty("deliveryAddress"))
        {object.deliveryAddress = $root.Address.toObject(message.deliveryAddress, options);}
        if (message.latestResolution != null && message.hasOwnProperty("latestResolution")) {
            object.latestResolution = $root.CampaignApplicationResolution.toObject(message.latestResolution, options);
            if (options.oneofs)
            {object._latestResolution = "latestResolution";}
        }
        if (message.pendingResolution != null && message.hasOwnProperty("pendingResolution")) {
            object.pendingResolution = $root.CampaignApplicationResolution.toObject(message.pendingResolution, options);
            if (options.oneofs)
            {object._pendingResolution = "pendingResolution";}
        }
        if (message.isDelivered != null && message.hasOwnProperty("isDelivered")) {
            object.isDelivered = message.isDelivered;
            if (options.oneofs)
            {object._isDelivered = "isDelivered";}
        }
        if (message.deliveryConfirmedAt != null && message.hasOwnProperty("deliveryConfirmedAt")) {
            if (typeof message.deliveryConfirmedAt === "number")
            {object.deliveryConfirmedAt = options.longs === String ? String(message.deliveryConfirmedAt) : message.deliveryConfirmedAt;}
            else
            {object.deliveryConfirmedAt = options.longs === String ? $util.Long.prototype.toString.call(message.deliveryConfirmedAt) : options.longs === Number ? new $util.LongBits(message.deliveryConfirmedAt.low >>> 0, message.deliveryConfirmedAt.high >>> 0).toNumber() : message.deliveryConfirmedAt;}
            if (options.oneofs)
            {object._deliveryConfirmedAt = "deliveryConfirmedAt";}
        }
        if (message.dueReviewNotificationsAt && message.dueReviewNotificationsAt.length) {
            object.dueReviewNotificationsAt = [];
            for (let j = 0; j < message.dueReviewNotificationsAt.length; ++j)
            {if (typeof message.dueReviewNotificationsAt[j] === "number")
            {object.dueReviewNotificationsAt[j] = options.longs === String ? String(message.dueReviewNotificationsAt[j]) : message.dueReviewNotificationsAt[j];}
            else
            {object.dueReviewNotificationsAt[j] = options.longs === String ? $util.Long.prototype.toString.call(message.dueReviewNotificationsAt[j]) : options.longs === Number ? new $util.LongBits(message.dueReviewNotificationsAt[j].low >>> 0, message.dueReviewNotificationsAt[j].high >>> 0).toNumber() : message.dueReviewNotificationsAt[j];}}
        }
        if (message.deadlineAt != null && message.hasOwnProperty("deadlineAt")) {
            if (typeof message.deadlineAt === "number")
            {object.deadlineAt = options.longs === String ? String(message.deadlineAt) : message.deadlineAt;}
            else
            {object.deadlineAt = options.longs === String ? $util.Long.prototype.toString.call(message.deadlineAt) : options.longs === Number ? new $util.LongBits(message.deadlineAt.low >>> 0, message.deadlineAt.high >>> 0).toNumber() : message.deadlineAt;}
            if (options.oneofs)
            {object._deadlineAt = "deadlineAt";}
        }
        if (message.submittedReviewsCount != null && message.hasOwnProperty("submittedReviewsCount")) {
            object.submittedReviewsCount = message.submittedReviewsCount;
            if (options.oneofs)
            {object._submittedReviewsCount = "submittedReviewsCount";}
        }
        if (message.resolutions && message.resolutions.length) {
            object.resolutions = [];
            for (let j = 0; j < message.resolutions.length; ++j)
            {object.resolutions[j] = $root.CampaignApplicationResolution.toObject(message.resolutions[j], options);}
        }
        if (message.questionnaireResponseAnswers && message.questionnaireResponseAnswers.length) {
            object.questionnaireResponseAnswers = [];
            for (let j = 0; j < message.questionnaireResponseAnswers.length; ++j)
            {object.questionnaireResponseAnswers[j] = $root.KVPair.toObject(message.questionnaireResponseAnswers[j], options);}
        }
        if (message.isOrdered != null && message.hasOwnProperty("isOrdered")) {
            object.isOrdered = message.isOrdered;
            if (options.oneofs)
            {object._isOrdered = "isOrdered";}
        }
        if (message.orderConfirmedAt != null && message.hasOwnProperty("orderConfirmedAt")) {
            if (typeof message.orderConfirmedAt === "number")
            {object.orderConfirmedAt = options.longs === String ? String(message.orderConfirmedAt) : message.orderConfirmedAt;}
            else
            {object.orderConfirmedAt = options.longs === String ? $util.Long.prototype.toString.call(message.orderConfirmedAt) : options.longs === Number ? new $util.LongBits(message.orderConfirmedAt.low >>> 0, message.orderConfirmedAt.high >>> 0).toNumber() : message.orderConfirmedAt;}
            if (options.oneofs)
            {object._orderConfirmedAt = "orderConfirmedAt";}
        }
        return object;
    };

    /**
     * Converts this CampaignApplication to JSON.
     * @function toJSON
     * @memberof CampaignApplication
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CampaignApplication.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CampaignApplication
     * @function getTypeUrl
     * @memberof CampaignApplication
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CampaignApplication.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CampaignApplication";
    };

    return CampaignApplication;
})();

export const CampaignApplicationResolution = $root.CampaignApplicationResolution = (() => {

    /**
     * Properties of a CampaignApplicationResolution.
     * @exports ICampaignApplicationResolution
     * @interface ICampaignApplicationResolution
     * @property {CampaignApplicationResolutionStatus|null} [status] CampaignApplicationResolution status
     * @property {number|Long|null} [resolvedAt] CampaignApplicationResolution resolvedAt
     * @property {string|null} [message] CampaignApplicationResolution message
     */

    /**
     * Constructs a new CampaignApplicationResolution.
     * @exports CampaignApplicationResolution
     * @classdesc Represents a CampaignApplicationResolution.
     * @implements ICampaignApplicationResolution
     * @constructor
     * @param {ICampaignApplicationResolution=} [properties] Properties to set
     */
    function CampaignApplicationResolution(properties) {
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * CampaignApplicationResolution status.
     * @member {CampaignApplicationResolutionStatus} status
     * @memberof CampaignApplicationResolution
     * @instance
     */
    CampaignApplicationResolution.prototype.status = 1;

    /**
     * CampaignApplicationResolution resolvedAt.
     * @member {number|Long} resolvedAt
     * @memberof CampaignApplicationResolution
     * @instance
     */
    CampaignApplicationResolution.prototype.resolvedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * CampaignApplicationResolution message.
     * @member {string|null|undefined} message
     * @memberof CampaignApplicationResolution
     * @instance
     */
    CampaignApplicationResolution.prototype.message = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * CampaignApplicationResolution _message.
     * @member {"message"|undefined} _message
     * @memberof CampaignApplicationResolution
     * @instance
     */
    Object.defineProperty(CampaignApplicationResolution.prototype, "_message", {
        get: $util.oneOfGetter($oneOfFields = ["message"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new CampaignApplicationResolution instance using the specified properties.
     * @function create
     * @memberof CampaignApplicationResolution
     * @static
     * @param {ICampaignApplicationResolution=} [properties] Properties to set
     * @returns {CampaignApplicationResolution} CampaignApplicationResolution instance
     */
    CampaignApplicationResolution.create = function create(properties) {
        return new CampaignApplicationResolution(properties);
    };

    /**
     * Encodes the specified CampaignApplicationResolution message. Does not implicitly {@link CampaignApplicationResolution.verify|verify} messages.
     * @function encode
     * @memberof CampaignApplicationResolution
     * @static
     * @param {ICampaignApplicationResolution} message CampaignApplicationResolution message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignApplicationResolution.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
        {writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);}
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
        {writer.uint32(/* id 2, wireType 0 =*/16).int64(message.resolvedAt);}
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
        {writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);}
        return writer;
    };

    /**
     * Encodes the specified CampaignApplicationResolution message, length delimited. Does not implicitly {@link CampaignApplicationResolution.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CampaignApplicationResolution
     * @static
     * @param {ICampaignApplicationResolution} message CampaignApplicationResolution message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CampaignApplicationResolution.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CampaignApplicationResolution message from the specified reader or buffer.
     * @function decode
     * @memberof CampaignApplicationResolution
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CampaignApplicationResolution} CampaignApplicationResolution
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignApplicationResolution.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CampaignApplicationResolution();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                message.status = reader.int32();
                break;
            }
            case 2: {
                message.resolvedAt = reader.int64();
                break;
            }
            case 3: {
                message.message = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CampaignApplicationResolution message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CampaignApplicationResolution
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CampaignApplicationResolution} CampaignApplicationResolution
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CampaignApplicationResolution.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CampaignApplicationResolution message.
     * @function verify
     * @memberof CampaignApplicationResolution
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CampaignApplicationResolution.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.status != null && message.hasOwnProperty("status"))
        {switch (message.status) {
        default:
            return "status: enum value expected";
        case 1:
        case 2:
        case 3:
            break;
        }}
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
        {if (!$util.isInteger(message.resolvedAt) && !(message.resolvedAt && $util.isInteger(message.resolvedAt.low) && $util.isInteger(message.resolvedAt.high)))
        {return "resolvedAt: integer|Long expected";}}
        if (message.message != null && message.hasOwnProperty("message")) {
            properties._message = 1;
            if (!$util.isString(message.message))
            {return "message: string expected";}
        }
        return null;
    };

    /**
     * Creates a CampaignApplicationResolution message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CampaignApplicationResolution
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CampaignApplicationResolution} CampaignApplicationResolution
     */
    CampaignApplicationResolution.fromObject = function fromObject(object) {
        if (object instanceof $root.CampaignApplicationResolution)
        {return object;}
        let message = new $root.CampaignApplicationResolution();
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "selected":
        case 1:
            message.status = 1;
            break;
        case "alternate":
        case 2:
            message.status = 2;
            break;
        case "rejected":
        case 3:
            message.status = 3;
            break;
        }
        if (object.resolvedAt != null)
        {if ($util.Long)
        {(message.resolvedAt = $util.Long.fromValue(object.resolvedAt)).unsigned = false;}
        else if (typeof object.resolvedAt === "string")
        {message.resolvedAt = parseInt(object.resolvedAt, 10);}
        else if (typeof object.resolvedAt === "number")
        {message.resolvedAt = object.resolvedAt;}
        else if (typeof object.resolvedAt === "object")
        {message.resolvedAt = new $util.LongBits(object.resolvedAt.low >>> 0, object.resolvedAt.high >>> 0).toNumber();}}
        if (object.message != null)
        {message.message = String(object.message);}
        return message;
    };

    /**
     * Creates a plain object from a CampaignApplicationResolution message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CampaignApplicationResolution
     * @static
     * @param {CampaignApplicationResolution} message CampaignApplicationResolution
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CampaignApplicationResolution.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.defaults) {
            object.status = options.enums === String ? "selected" : 1;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.resolvedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
            {object.resolvedAt = options.longs === String ? "0" : 0;}
        }
        if (message.status != null && message.hasOwnProperty("status"))
        {object.status = options.enums === String ? $root.CampaignApplicationResolutionStatus[message.status] === undefined ? message.status : $root.CampaignApplicationResolutionStatus[message.status] : message.status;}
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
        {if (typeof message.resolvedAt === "number")
        {object.resolvedAt = options.longs === String ? String(message.resolvedAt) : message.resolvedAt;}
        else
        {object.resolvedAt = options.longs === String ? $util.Long.prototype.toString.call(message.resolvedAt) : options.longs === Number ? new $util.LongBits(message.resolvedAt.low >>> 0, message.resolvedAt.high >>> 0).toNumber() : message.resolvedAt;}}
        if (message.message != null && message.hasOwnProperty("message")) {
            object.message = message.message;
            if (options.oneofs)
            {object._message = "message";}
        }
        return object;
    };

    /**
     * Converts this CampaignApplicationResolution to JSON.
     * @function toJSON
     * @memberof CampaignApplicationResolution
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CampaignApplicationResolution.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CampaignApplicationResolution
     * @function getTypeUrl
     * @memberof CampaignApplicationResolution
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CampaignApplicationResolution.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CampaignApplicationResolution";
    };

    return CampaignApplicationResolution;
})();

export const GetCampaignApplicationsResponse = $root.GetCampaignApplicationsResponse = (() => {

    /**
     * Properties of a GetCampaignApplicationsResponse.
     * @exports IGetCampaignApplicationsResponse
     * @interface IGetCampaignApplicationsResponse
     * @property {Array.<ICampaignApplication>|null} [items] GetCampaignApplicationsResponse items
     * @property {string|null} [nextToken] GetCampaignApplicationsResponse nextToken
     */

    /**
     * Constructs a new GetCampaignApplicationsResponse.
     * @exports GetCampaignApplicationsResponse
     * @classdesc Represents a GetCampaignApplicationsResponse.
     * @implements IGetCampaignApplicationsResponse
     * @constructor
     * @param {IGetCampaignApplicationsResponse=} [properties] Properties to set
     */
    function GetCampaignApplicationsResponse(properties) {
        this.items = [];
        if (properties)
        {for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
        {if (properties[keys[i]] != null)
        {this[keys[i]] = properties[keys[i]];}}}
    }

    /**
     * GetCampaignApplicationsResponse items.
     * @member {Array.<ICampaignApplication>} items
     * @memberof GetCampaignApplicationsResponse
     * @instance
     */
    GetCampaignApplicationsResponse.prototype.items = $util.emptyArray;

    /**
     * GetCampaignApplicationsResponse nextToken.
     * @member {string|null|undefined} nextToken
     * @memberof GetCampaignApplicationsResponse
     * @instance
     */
    GetCampaignApplicationsResponse.prototype.nextToken = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * GetCampaignApplicationsResponse _nextToken.
     * @member {"nextToken"|undefined} _nextToken
     * @memberof GetCampaignApplicationsResponse
     * @instance
     */
    Object.defineProperty(GetCampaignApplicationsResponse.prototype, "_nextToken", {
        get: $util.oneOfGetter($oneOfFields = ["nextToken"]),
        set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new GetCampaignApplicationsResponse instance using the specified properties.
     * @function create
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {IGetCampaignApplicationsResponse=} [properties] Properties to set
     * @returns {GetCampaignApplicationsResponse} GetCampaignApplicationsResponse instance
     */
    GetCampaignApplicationsResponse.create = function create(properties) {
        return new GetCampaignApplicationsResponse(properties);
    };

    /**
     * Encodes the specified GetCampaignApplicationsResponse message. Does not implicitly {@link GetCampaignApplicationsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {IGetCampaignApplicationsResponse} message GetCampaignApplicationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetCampaignApplicationsResponse.encode = function encode(message, writer) {
        if (!writer)
        {writer = $Writer.create();}
        if (message.items != null && message.items.length)
        {for (let i = 0; i < message.items.length; ++i)
        {$root.CampaignApplication.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();}}
        if (message.nextToken != null && Object.hasOwnProperty.call(message, "nextToken"))
        {writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextToken);}
        return writer;
    };

    /**
     * Encodes the specified GetCampaignApplicationsResponse message, length delimited. Does not implicitly {@link GetCampaignApplicationsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {IGetCampaignApplicationsResponse} message GetCampaignApplicationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetCampaignApplicationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetCampaignApplicationsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetCampaignApplicationsResponse} GetCampaignApplicationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetCampaignApplicationsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
        {reader = $Reader.create(reader);}
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetCampaignApplicationsResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                if (!(message.items && message.items.length))
                {message.items = [];}
                message.items.push($root.CampaignApplication.decode(reader, reader.uint32()));
                break;
            }
            case 2: {
                message.nextToken = reader.string();
                break;
            }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetCampaignApplicationsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetCampaignApplicationsResponse} GetCampaignApplicationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetCampaignApplicationsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
        {reader = new $Reader(reader);}
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetCampaignApplicationsResponse message.
     * @function verify
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetCampaignApplicationsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
        {return "object expected";}
        let properties = {};
        if (message.items != null && message.hasOwnProperty("items")) {
            if (!Array.isArray(message.items))
            {return "items: array expected";}
            for (let i = 0; i < message.items.length; ++i) {
                let error = $root.CampaignApplication.verify(message.items[i]);
                if (error)
                {return "items." + error;}
            }
        }
        if (message.nextToken != null && message.hasOwnProperty("nextToken")) {
            properties._nextToken = 1;
            if (!$util.isString(message.nextToken))
            {return "nextToken: string expected";}
        }
        return null;
    };

    /**
     * Creates a GetCampaignApplicationsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetCampaignApplicationsResponse} GetCampaignApplicationsResponse
     */
    GetCampaignApplicationsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetCampaignApplicationsResponse)
        {return object;}
        let message = new $root.GetCampaignApplicationsResponse();
        if (object.items) {
            if (!Array.isArray(object.items))
            {throw TypeError(".GetCampaignApplicationsResponse.items: array expected");}
            message.items = [];
            for (let i = 0; i < object.items.length; ++i) {
                if (typeof object.items[i] !== "object")
                {throw TypeError(".GetCampaignApplicationsResponse.items: object expected");}
                message.items[i] = $root.CampaignApplication.fromObject(object.items[i]);
            }
        }
        if (object.nextToken != null)
        {message.nextToken = String(object.nextToken);}
        return message;
    };

    /**
     * Creates a plain object from a GetCampaignApplicationsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {GetCampaignApplicationsResponse} message GetCampaignApplicationsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetCampaignApplicationsResponse.toObject = function toObject(message, options) {
        if (!options)
        {options = {};}
        let object = {};
        if (options.arrays || options.defaults)
        {object.items = [];}
        if (message.items && message.items.length) {
            object.items = [];
            for (let j = 0; j < message.items.length; ++j)
            {object.items[j] = $root.CampaignApplication.toObject(message.items[j], options);}
        }
        if (message.nextToken != null && message.hasOwnProperty("nextToken")) {
            object.nextToken = message.nextToken;
            if (options.oneofs)
            {object._nextToken = "nextToken";}
        }
        return object;
    };

    /**
     * Converts this GetCampaignApplicationsResponse to JSON.
     * @function toJSON
     * @memberof GetCampaignApplicationsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetCampaignApplicationsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetCampaignApplicationsResponse
     * @function getTypeUrl
     * @memberof GetCampaignApplicationsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetCampaignApplicationsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetCampaignApplicationsResponse";
    };

    return GetCampaignApplicationsResponse;
})();

/**
 * ReviewerGender enum.
 * @exports ReviewerGender
 * @enum {number}
 * @property {number} male=1 male value
 * @property {number} female=2 female value
 * @property {number} other=3 other value
 */
export const ReviewerGender = $root.ReviewerGender = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "male"] = 1;
    values[valuesById[2] = "female"] = 2;
    values[valuesById[3] = "other"] = 3;
    return values;
})();

/**
 * CampaignApplicationState enum.
 * @exports CampaignApplicationState
 * @enum {number}
 * @property {number} draft=1 draft value
 * @property {number} submitted=2 submitted value
 * @property {number} pending=3 pending value
 * @property {number} resolved=4 resolved value
 */
export const CampaignApplicationState = $root.CampaignApplicationState = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "draft"] = 1;
    values[valuesById[2] = "submitted"] = 2;
    values[valuesById[3] = "pending"] = 3;
    values[valuesById[4] = "resolved"] = 4;
    return values;
})();

/**
 * CampaignApplicationResolutionStatus enum.
 * @exports CampaignApplicationResolutionStatus
 * @enum {number}
 * @property {number} selected=1 selected value
 * @property {number} alternate=2 alternate value
 * @property {number} rejected=3 rejected value
 */
export const CampaignApplicationResolutionStatus = $root.CampaignApplicationResolutionStatus = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "selected"] = 1;
    values[valuesById[2] = "alternate"] = 2;
    values[valuesById[3] = "rejected"] = 3;
    return values;
})();

export { $root as default };
